webpackJsonp([2],{

/***/ "+Un9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"projectList":"projectList__3A_lw","loadWrapper":"loadWrapper__DoJXj","hideButtons":"hideButtons__3dx6e","buttons":"buttons__IHbr5","containerClass":"containerClass__30VLP","headerContainerClass":"headerContainerClass__3yq60","tableBodyClass":"tableBodyClass__2EznD","toolBarStyle":"toolBarStyle__39WCN","row":"row__3QJXn","toolBar":"toolBar__2V0dp","searchWrapper":"searchWrapper__1tKXo","insertBtnWrapper":"insertBtnWrapper__33Aqn","priceColumn":"priceColumn__1nJsg","poId":"poId__3XNLT","vendor":"vendor__3Brre","description":"description__1C0Ug","date":"date__1ic4L","amount":"amount__3rDWg","preloaderWrapper":"preloaderWrapper__7_7iI","tableOuterWrapper":"tableOuterWrapper__245Yg","cardListOuterWrapper":"cardListOuterWrapper__1YxLl","viewDetailsIcon":"viewDetailsIcon__G32x0","purchaseOrderDescCards":"purchaseOrderDescCards__2z7o-","projectId":"projectId__3J9KE","vendorWrapper":"vendorWrapper__22mvL","docCategorylabel":"docCategorylabel__3aRAK","docCategorytext":"docCategorytext__3doSl","purchaseOrderDescription":"purchaseOrderDescription__3DCsS","amountDateWrapper":"amountDateWrapper__WPQ8E"};

/***/ }),

/***/ "/NpY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"projectTablesection":"projectTablesection__2rzh6","projectList":"projectList__2nXv6","headerContainerClass":"headerContainerClass__1tuTj","tableBodyClass":"tableBodyClass__3hUQ0","viewDetail":"viewDetail__3GO4L","exapnadlbleRow":"exapnadlbleRow__OQc1l","themeBtn":"themeBtn__5daL3","themeBtn1":"themeBtn1__1zSB0","selectedRow":"selectedRow__3Wz2g","view_results":"view_results__2dLlc","preloaderWrapper":"preloaderWrapper__3V35j","tableOuterWrapper":"tableOuterWrapper__3mh7Z","cardListOuterWrapper":"cardListOuterWrapper__2UG02","idClass":"idClass__3gsA3"};

/***/ }),

/***/ "31tI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_image_gallery__ = __webpack_require__("uq96");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_image_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_image_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("CeE8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PictureGallery = function (_Component) {
  _inherits(PictureGallery, _Component);

  function PictureGallery() {
    _classCallCheck(this, PictureGallery);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PictureGallery.prototype.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_react_image_gallery___default.a, {
      showFullscreenButton: false,
      showPlayButton: false,
      showBullets: true,
      width: 300,
      height: 300,
      originalClass: __WEBPACK_IMPORTED_MODULE_3__style___default.a.image_sizewrapper,
      items: this.props.pictureList.data
    });
  };

  return PictureGallery;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "4PZ+":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = debounce;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "4VU6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bodyContainerClass":"bodyContainerClass__3xHiB","tableBodyClass":"tableBodyClass__3HNyC","headerContainerClass":"headerContainerClass__3Sw0X","headerImage":"headerImage__2lmY3","cellElement":"cellElement__35_XK","policyMarker":"policyMarker__1N2mu","budgetUtiWrapper":"budgetUtiWrapper__2LgFL","budgetInnerWrapper":"budgetInnerWrapper__Je75m","countryColumn":"countryColumn__Tp42J","yearColumn":"yearColumn__3VyUD","regularColumn":"regularColumn__3PqwC","othersColumn":"othersColumn__ow3aA","parent":"parent__1rp1Q","container":"container__2vXMZ","gender_equality":"gender_equality__2OfI1","gender_equality_item":"gender_equality_item__2El3l","marker_container":"marker_container__1wLbN","item_title":"item_title__1einc","textCenter":"textCenter__gZU-1","budgetBackground":"budgetBackground__1fEp-","child":"child__1gI4Y","markerSection":"markerSection__1-Hqe","parentMarkers":"parentMarkers__1YjYQ","level":"level__2mulP","imageSection":"imageSection__IZlhK","textSection":"textSection__3k1L7","sub_header":"sub_header__w2Wgy","marker_header":"marker_header__10fxU","sub_level":"sub_level__3Vl-7","track_vertical":"track_vertical__2ti1k","thumb_vertical":"thumb_vertical__85Y7k","thumb_horizontal":"thumb_horizontal__3-Rf4","sub_section_container":"sub_section_container__1Md1V","sub_section":"sub_section__2BtYw","bullet":"bullet__2TO8s","parent_container":"parent_container__2hxxz","table_container":"table_container__2IPg-","child_container":"child_container__LH3Ko","subTables":"subTables__2yt7R","item_budget":"item_budget__nA8jN","budget_list":"budget_list__3IKV3","alignment":"alignment__1mc19","alignment_right":"alignment_right__mTUpK","budget_container":"budget_container__wX1mx","card_container":"card_container__3Yy0-","child_item":"child_item__1EHLw","modal":"modal__1az3C","modalWrapper":"modalWrapper__1VbKM","outerContainer":"outerContainer__mne0Y","modalContainer":"modalContainer__3pvDe","modalContent":"modalContent__3LDpk","mobile":"mobile__2UBiX","yearWrapper":"yearWrapper__1GOwx","desktop":"desktop__1Fd9a","headerWrapper":"headerWrapper__2sRAj","closeBtn":"closeBtn__1SVcM","resultsHeader":"resultsHeader__NlVwX","detailWrapper":"detailWrapper__3AEiW","detailsSection":"detailsSection__1EzWe","sideNumber":"sideNumber__1LJL7","yearBtn":"yearBtn__Y3oLD","activeYear":"activeYear__e1wIt","footerContainer":"footerContainer__ankFc","footerDataWrapper":"footerDataWrapper__RL7xO","priceColumn":"priceColumn__tF87K","results_container":"results_container__1GYvB","results_item":"results_item__1oNx_","results_container_wrapper":"results_container_wrapper__1E-Lh"};

/***/ }),

/***/ "CamH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export projectDetailDocData */
var projectDetailDocData = [{
    date: "Nov 10, 2017",
    document: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    dateCategory: 'Project document'
}, {
    date: "Nov 11, 2017",
    document: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    dateCategory: 'Budget'
}, {
    date: "Nov 12, 2017",
    document: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    dateCategory: 'Project Reports'
}, {
    date: "Nov 13, 2017",
    document: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    dateCategory: 'Evalulation Reports'
}];

/***/ }),

/***/ "FNy/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = throttle;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "G9P3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BudgetSource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("zgDO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router__ = __webpack_require__("/QC5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_utils_numberFormatter__ = __webpack_require__("Au7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_utils_commonMethods__ = __webpack_require__("Cdrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__no_data_template__ = __webpack_require__("wdDn");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__no_data_template__["a" /* default */], null);

var BudgetSource = function (_Component) {
	_inherits(BudgetSource, _Component);

	function BudgetSource(props) {
		_classCallCheck(this, BudgetSource);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			budget_source: []
		};

		_this.dataSorting = function () {
			/**Sorting - Start*/
			if (_this.state.budget_source.length !== 0) {
				var data = _this.state.budget_source.slice();
				data.sort(function (a, b) {
					return a.budget - b.budget;
				});

				/**Sorting - End*/

				var id = 0;
				var result = data.map(function (el) {
					var o = _extends({}, el);
					o.id = id++;
					return o;
				});

				_this.setState({
					budget_source: result
				}, function () {
					_this.setFontSize();
				});
			}
		};

		_this.setFontSize = function () {
			var budget_source = _this.state.budget_source;

			var widthOfDevice = window.outerWidth;
			var division = budget_source[budget_source.length - 1].budget / 15;
			if (widthOfDevice <= 480) {
				budget_source[0].fontSize = 16;
				budget_source[budget_source.length - 1].fontSize = budget_source[budget_source.length - 1].budget > 0 ? 30 : 16;
			} else {
				budget_source[0].fontSize = 14;
				budget_source[budget_source.length - 1].fontSize = budget_source[budget_source.length - 1].budget > 0 ? 30 : 14;
			}

			budget_source.map(function (el, index) {
				if (index != 0 && index != budget_source.length - 1) {
					var priceDiff = division > 0 ? el.budget / division : 0;

					if (widthOfDevice <= 480) {
						budget_source[index].fontSize = 16 + parseInt(priceDiff, 10);
					} else {
						budget_source[index].fontSize = 16 + parseInt(priceDiff, 10);
					}
				}
			});
			_this.setState(_extends({}, _this.state, {
				budget_source: budget_source
			}));
		};

		_this.getStyles = function (id) {
			var currentEl = {};
			_this.state.budget_source.length > 0 && _this.state.budget_source.map(function (el) {
				if (el.id === id) {
					currentEl = el;
				}
			});
			var styles = {

				fontSize: currentEl.fontSize + 'px'
			};
			return styles;
		};

		_this.getBudgetStyles = function (id) {
			var currentEl = {};
			_this.state.budget_source.length > 0 && _this.state.budget_source.map(function (el) {
				if (el.id === id) {
					currentEl = el;
				}
			});
			var styles = {
				fontSize: currentEl.fontSize < 18 ? currentEl.fontSize * 0.90 + 'px' : currentEl.fontSize * 0.75 + 'px'
			};
			return styles;
		};

		_this.onSelectBudgetSource = function (budget_source) {
			if (_this.props.embed) {
				Object(__WEBPACK_IMPORTED_MODULE_4__src_utils_commonMethods__["g" /* openInNewTab */])('/profile/' + budget_source.organisation + '/donorprofile', function () {});
			} else {
				Object(__WEBPACK_IMPORTED_MODULE_2_preact_router__["route"])('/profile/' + budget_source.organisation + '/donorprofile');
			}
		};

		_this.state = {
			budget_source: _this.props.data ? _this.props.data : []
		};
		return _this;
	}

	/*To dynamically calculate the font-size of each names in Tag Cloud = Start**/


	BudgetSource.prototype.componentWillMount = function componentWillMount() {
		this.dataSorting();
	};

	BudgetSource.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		var _this2 = this;

		if (nextProps.data !== this.props.data) this.setState({
			budget_source: nextProps.data
		}, function () {
			_this2.dataSorting();
		});
	};

	BudgetSource.prototype.render = function render() {
		var _this3 = this;

		var isBudgetSourceNonEmpty = this.props.data.length > 0;
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.budgetComponentWrapper },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.budgetWrapper },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'p',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.budgetHeading },
					'Donors (',
					this.state.budget_source.length,
					')'
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.projectWrapper },
					this.state.budget_source.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						null,
						this.state.budget_source.map(function (el, index) {
							return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'span',
								{ key: index, 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.project, onClick: function onClick() {
										_this3.onSelectBudgetSource(el);
									} },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'span',
									{ style: _this3.getBudgetStyles(el.id),
										className: __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.projectPrice },
									Object(__WEBPACK_IMPORTED_MODULE_3__src_utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(el.budget, 2)
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'p',
									{ style: _this3.getStyles(el.id) },
									el.organisation_name,
									' ',
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'strong',
										null,
										'(',
										el.iucn_member ? ' IUCN Member' : ' IUCN Non-member',
										')'
									)
								)
							);
						})
					) : _ref
				)
			)
		);
	};

	return BudgetSource;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "Gnd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/index.js
var projectDetailActions = __webpack_require__("csCp");

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ./components/projectDonutBarChart/donutBarChart/style.scss
var style = __webpack_require__("gxLQ");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./components/projectDonutBarChart/donutChart/style.scss
var donutChart_style = __webpack_require__("ykHf");
var donutChart_style_default = /*#__PURE__*/__webpack_require__.n(donutChart_style);

// EXTERNAL MODULE: ../node_modules/d3/d3.js
var d3 = __webpack_require__("tokj");
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// EXTERNAL MODULE: ./components/donut-chart-legend/index.js
var donut_chart_legend = __webpack_require__("kwbv");

// EXTERNAL MODULE: ./utils/commonActionUtils.js
var commonActionUtils = __webpack_require__("I9r4");

// CONCATENATED MODULE: ./components/projectDonutBarChart/donutChart/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var donutChart_DonutChart = function (_Component) {
    _inherits(DonutChart, _Component);

    function DonutChart(props) {
        _classCallCheck(this, DonutChart);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.drawDonut = function () {
            var EDGE = window.navigator.userAgent.indexOf("Edge") > -1,
                IE = false || !!document.documentMode,
                EDGE_IE = EDGE || IE;

            var that = _this;

            var data = _this.state.data;
            var width = _this.props.chartWidth ? _this.props.chartWidth : 400,
                height = _this.props.chartHeight ? _this.props.chartHeight : 400,
                radius = Math.min(width, height) / 2,
                labelr = radius + 40,
                outerRadius = _this.props.outerRadius || radius - 10,
                innerRadius = _this.props.innerRadius || radius - 70;

            var arc = d3_default.a.svg.arc().outerRadius(outerRadius).innerRadius(innerRadius);

            var pie = d3_default.a.layout.pie().sort(null).value(function (d) {
                return d.percentage;
            }).padAngle(0);

            var onHover = function onHover(d) {
                _this.setState({
                    label: d.data.fund_stream || d.data.fund_type || d.data.sector_name || d.data.sdg_name,
                    index: d.data && d.data.sdg_name && _this.props.sdgIndex ? _this.props.sdgIndex.find(function (sdg) {
                        return sdg.name === d.data.sdg_name;
                    }).code : null,
                    percentage: d.data.percentage,
                    sdg_code: d.data.sdg_code,
                    total_contribution: !isNaN(d.data.total_contribution) ? d.data.total_contribution : d.data.budget ? d.data.budget : d.data.theme_budget
                }, function () {});
            };

            if (!d3_default.a.select('#' + _this.props.chart_id).empty()) {
                d3_default.a.select('#' + _this.props.chart_id + ' svg').remove();
            }

            var svg = d3_default.a.select('#' + _this.props.chart_id).append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", "0 0 " + width + " " + height).classed(donutChart_style_default.a.svgIe + ' ' + _this.props.svgIe, true).append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ") scale(0.7, 0.7)");

            var g = svg.selectAll(".arc").data(pie(data)).enter().append("g").attr("class", "arc");

            var newArcs = g.append("path").attr("d", arc).style("fill", function (d) {
                return "#" + (d.data.color || d.data.sector_color || d.data.sdg_color);
            });

            var _newArcs$ = newArcs[0],
                firstArc = _newArcs$[0],
                lastArc = _newArcs$.slice(1);

            firstArc.style.opacity = 1;
            firstArc.setAttribute("transform", 'scale(1.025,1.025)');
            firstArc.style.stroke = "#eee";
            firstArc.style.strokeWidth = "1px";
            lastArc.forEach(function (item) {
                item.style.transform = 'scale(1, 1)';
                item.style.stroke = "#eee";
                item.style.strokeWidth = "1px";
            });
            !_this.props.exportLegend && newArcs.on("mouseover", function (d, i) {

                if (EDGE_IE) {
                    var newArray = [];
                    d3_default.a.select('#' + that.props.chart_id).selectAll(".arc")[0].forEach(function (item) {

                        for (var i = 0, len = item.childNodes.length; i < 1; ++i) {
                            var child = item.childNodes[i];
                            newArray.push(child);
                            if (child.nodeType !== 1 /*Node.ELEMENT_NODE*/) continue;
                            // Now, do whatever you want with the child element.
                        }
                    });
                    var all = [].concat(newArray);

                    all.forEach(function (item) {
                        item.style.opacity = 1;
                        item.setAttribute("transform", 'scale(1,1)');
                    });

                    var current = d3_default.a.event.target;
                    current.setAttribute("transform", 'scale(1.025,1.025)');
                    current.style.stroke = "#eee";
                    current.style.strokeWidth = "1px";
                    onHover(d);
                } else {
                    var all = d3_default.a.select('#' + that.props.chart_id).selectAll(".arc")[0].filter(function (item) {
                        return item.children && item.children[0] !== d3_default.a.event.target;
                    });
                    d3_default.a.selectAll(all).selectAll("path").style('transform', 'scale(1,1)').style('opacity', 1);

                    var _current = d3_default.a.event.target;
                    _current.style.transform = 'scale(1.025,1.025)';
                    _current.style.stroke = "#eee";
                    _current.style.strokeWidth = "1px";
                    onHover(d);
                }
            });
        };

        _this.state = {
            data: _this.props.data ? _this.props.data : [],
            label: _this.props.data[0] && (_this.props.data[0].fund_stream || _this.props.data[0].fund_type || _this.props.data[0].sector_name || _this.props.data[0].sdg_name) ? _this.props.data[0].fund_stream || _this.props.data[0].fund_type || _this.props.data[0].sector_name || _this.props.data[0].sdg_name : "",
            index: _this.props.data && _this.props.data[0].sdg_name && _this.props.sdgIndex ? _this.props.sdgIndex.find(function (sdg) {
                return sdg.name === _this.props.data[0].sdg_name;
            }).code : null,
            sdg_code: _this.props.data[0] && _this.props.data[0].sdg_code ? _this.props.data[0].sdg_code : "",
            percentage: _this.props.data[0] && _this.props.data[0].percentage ? _this.props.data[0].percentage : 0,
            total_contribution: _this.props.data[0] ? !isNaN(_this.props.data[0].total_contribution) ? _this.props.data[0].total_contribution : _this.props.data[0].budget ? _this.props.data[0].budget : _this.props.data[0].theme_budget : 0
        };
        return _this;
    }

    DonutChart.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        this.setState({
            data: nextProps.data,
            label: nextProps.data[0] && (nextProps.data[0].fund_stream || nextProps.data[0].fund_type || nextProps.data[0].sector_name || this.props.data[0].sdg_name) ? nextProps.data[0].fund_stream || nextProps.data[0].fund_type || nextProps.data[0].sector_name || this.props.data[0].sdg_name : "",
            index: this.props.data && this.props.data[0].sdg_name && this.props.sdgIndex ? this.props.sdgIndex.find(function (sdg) {
                return sdg.name === _this2.props.data[0].sdg_name;
            }).code : null,
            sdg_code: nextProps.data[0] && nextProps.data[0].sdg_code ? nextProps.data[0].sdg_code : "",
            percentage: nextProps.data[0] && nextProps.data[0].percentage ? nextProps.data[0].percentage : 0,
            total_contribution: nextProps.data[0] ? !isNaN(nextProps.data[0].total_contribution) ? nextProps.data[0].total_contribution : nextProps.data[0].budget ? nextProps.data[0].budget : nextProps.data[0].theme_budget : 0
        }, function () {
            if (nextProps.data.length !== 0) {
                _this2.drawDonut();
            }
        });
    };

    DonutChart.prototype.componentDidMount = function componentDidMount() {
        if (this.props.data.length !== 0 && this.props.chart_id) {
            this.drawDonut();
        }
    };

    DonutChart.prototype.calculateTotalContribution = function calculateTotalContribution(dataset) {
        var total_contribution = 0;
        dataset.forEach(function (item, index) {
            total_contribution += item.theme_budget;
        });
        return Object(numberFormatter["d" /* numberToCurrencyFormatter */])(parseFloat(total_contribution), 2);
    };

    DonutChart.prototype.render = function render(props, _ref) {
        var label = _ref.label,
            percentage = _ref.percentage,
            total_contribution = _ref.total_contribution,
            sdg_code = _ref.sdg_code,
            index = _ref.index;

        var sdg_src = sdg_code && Object(commonActionUtils["c" /* getSDGImageFromCode */])(sdg_code);

        return Object(preact_min["h"])(
            'div',
            { 'class': donutChart_style_default.a.donut_wrapper + ' ' + this.props.donor_wrapper_styles, style: { marginTop: 14 } },
            Object(preact_min["h"])(
                'div',
                { 'class': donutChart_style_default.a.donut + ' ' + this.props.donut_styles, id: this.props.chart_id },
                !this.props.exportLegend && (percentage != 0 || percentage != "") ? Object(preact_min["h"])(
                    'div',
                    { 'class': this.props.percDiv },
                    Object(preact_min["h"])(
                        'section',
                        { 'class': donutChart_style_default.a.textLabel + ' ' + this.props.textWrapperStyle },
                        sdg_code ? Object(preact_min["h"])(
                            'span',
                            { 'class': donutChart_style_default.a.imageWrapper },
                            Object(preact_min["h"])('img', { 'class': donutChart_style_default.a.sdg_image, src: '../../../static/assets/icons/' + sdg_src, alt: 'sdg image' })
                        ) : null,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': donutChart_style_default.a.perc + ' ' + this.props.donutCenterText },
                            percentage == parseInt(percentage) ? parseFloat(percentage).toFixed(1) + '%' : percentage >= 1 ? parseFloat(percentage).toFixed(1) + '%' : '< 1%'
                        ),
                        total_contribution ? Object(preact_min["h"])(
                            'span',
                            { 'class': donutChart_style_default.a.dollor + ' ' + this.props.dollor },
                            Object(numberFormatter["d" /* numberToCurrencyFormatter */])(total_contribution, 2)
                        ) : Object(preact_min["h"])(
                            'span',
                            { 'class': donutChart_style_default.a.perc + ' ' + donutChart_style_default.a.contributionText + ' ' + this.props.donutCenterText },
                            Object(numberFormatter["d" /* numberToCurrencyFormatter */])(percentage)
                        )
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': donutChart_style_default.a.textField + ' ' + this.props.textFieldStyle },
                        index,
                        '. ',
                        label
                    )
                ) : null,
                this.props.exportLegend && Object(preact_min["h"])(
                    'section',
                    { 'class': donutChart_style_default.a.textLabel + ' ' + this.props.textWrapperStyle },
                    Object(preact_min["h"])(
                        'span',
                        { 'class': donutChart_style_default.a.dollor },
                        this.calculateTotalContribution(props.data)
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': donutChart_style_default.a.textField + ' ' + this.props.textFieldStyle },
                        'Total Contribution'
                    )
                )
            ),
            this.props.displayLegend && this.props.displayLegend == 'false' ? null : Object(preact_min["h"])(
                'div',
                { 'class': donutChart_style_default.a.legend + ' ' + this.props.legend_styles + ' ' + this.props.ourFocusLegendStyles },
                Object(preact_min["h"])(donut_chart_legend["a" /* default */], { legendLabel: this.props.legendLabel, legendData: this.props.legendData })
            ),
            this.props.exportLegend ? Object(preact_min["h"])(
                'div',
                { 'class': donutChart_style_default.a.exportLegend + ' ' + this.props.legend_styles },
                Object(preact_min["h"])(
                    'ul',
                    { 'class': donutChart_style_default.a.legendWrapper },
                    this.props.data.map(function (item, index) {
                        return Object(preact_min["h"])(
                            'li',
                            { 'class': donutChart_style_default.a.legendItem },
                            Object(preact_min["h"])('span', { 'class': donutChart_style_default.a.legendColor, style: { backgroundColor: '#' + item.color } }),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': donutChart_style_default.a.legendDescription },
                                item.fund_stream
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': donutChart_style_default.a.legendPercentage },
                                Object(numberFormatter["f" /* roundTo */])(item.percentage, 2),
                                '%'
                            )
                        );
                    })
                )
            ) : null
        );
    };

    return DonutChart;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/listView/index.js + 1 modules
var listView = __webpack_require__("lo/D");

// EXTERNAL MODULE: ./components/projectDonutBarChart/donutBarChart/components/barChartItem/style.scss
var barChartItem_style = __webpack_require__("ygBH");
var barChartItem_style_default = /*#__PURE__*/__webpack_require__.n(barChartItem_style);

// CONCATENATED MODULE: ./components/projectDonutBarChart/donutBarChart/components/barChartItem/index.js


function barChartItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function barChartItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function barChartItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var barChartItem_ChartItem = function (_Component) {
  barChartItem__inherits(ChartItem, _Component);

  function ChartItem(props, context) {
    barChartItem__classCallCheck(this, ChartItem);

    var _this = barChartItem__possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.state = {
      styles: {
        allDonorWrapper: {
          width: _this.props.data.budgetPercentage + "%",
          height: 25,
          backgroundColor: '#42689b',
          borderLeftWidth: 1,
          borderColor: '#42689b',
          verticalAlign: "middle"
        },
        countryWrapper: {
          width: _this.props.data.expensePercentage + "%",
          height: 25,
          backgroundColor: "#cae1f7",
          verticalAlign: "middle"
        }
      }
    };
    return _this;
  }

  ChartItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      styles: {
        allDonorWrapper: {
          height: 25,
          verticalAlign: "middle",
          width: nextProps.data.budgetPercentage + "%",
          backgroundColor: '#42689b',
          borderLeftWidth: 1,
          borderColor: '#42689b'
        },
        countryWrapper: {
          width: nextProps.data.expensePercentage + "%",
          height: 25,
          backgroundColor: "#cae1f7",
          verticalAlign: "middle"
        }
      }
    });
  };

  ChartItem.prototype.render = function render() {
    var _this2 = this;

    var sdg_src = this.props.data.sdg_code && Object(commonActionUtils["c" /* getSDGImageFromCode */])(this.props.data.sdg_code);
    return Object(preact_min["h"])(
      "section",
      { "class": barChartItem_style_default.a.wrapper + " " + barChartItem_style_default.a.wrapperSdg },
      Object(preact_min["h"])(
        "div",
        { "class": barChartItem_style_default.a.rowLegend },
        this.props.data.sdg_code ? Object(preact_min["h"])(
          "span",
          { "class": barChartItem_style_default.a.imageWrapper },
          Object(preact_min["h"])("img", { "class": barChartItem_style_default.a.sdg_image, src: "../../../static/assets/icons/" + sdg_src, alt: "sdg image" })
        ) : Object(preact_min["h"])("div", { "class": barChartItem_style_default.a.innerLegend, style: { backgroundColor: '#' + this.props.data.sdg_color } })
      ),
      Object(preact_min["h"])(
        "div",
        { "class": barChartItem_style_default.a.row },
        Object(preact_min["h"])(
          "span",
          { "class": barChartItem_style_default.a.barType },
          this.props.data.sector_name ? this.props.data.sector_name : this.props.sdgIndex ? this.props.sdgIndex.find(function (sdg) {
            return sdg.name === _this2.props.data.sdg_name;
          }).code + '. ' + this.props.data.sdg_name : this.props.data.sdg_name
        )
      ),
      Object(preact_min["h"])(
        "div",
        { "class": barChartItem_style_default.a.row, style: { marginTop: 'auto', marginBottom: 'auto' } },
        Object(preact_min["h"])(
          "div",
          { "class": barChartItem_style_default.a.rowWrapper },
          Object(preact_min["h"])("div", {
            "class": barChartItem_style_default.a.allDonorWrapper + " " + barChartItem_style_default.a.rowWrapperItem,
            style: this.state.styles.allDonorWrapper
          }),
          Object(preact_min["h"])(
            "div",
            { "class": barChartItem_style_default.a.text, style: { left: this.state.styles.allDonorWrapper.width, width: 'max-content' } },
            Object(preact_min["h"])(
              "span",
              { "class": barChartItem_style_default.a.barValue },
              Object(numberFormatter["d" /* numberToCurrencyFormatter */])(this.props.data.sdg_budget, 2)
            )
          )
        ),
        Object(preact_min["h"])(
          "div",
          { "class": barChartItem_style_default.a.rowWrapper },
          Object(preact_min["h"])("div", {
            "class": barChartItem_style_default.a.countryWrapper + " " + barChartItem_style_default.a.rowWrapperItem,
            style: this.state.styles.countryWrapper
          }),
          Object(preact_min["h"])(
            "div",
            { "class": barChartItem_style_default.a.text, style: { left: this.state.styles.allDonorWrapper.width, width: 'max-content' } },
            Object(preact_min["h"])(
              "span",
              { "class": barChartItem_style_default.a.barValue },
              Object(numberFormatter["d" /* numberToCurrencyFormatter */])(this.props.data.sdg_expense, 2)
            )
          )
        )
      )
    );
  };

  return ChartItem;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/projectDonutBarChart/donutBarChart/components/groupedBarChart/style.scss
var groupedBarChart_style = __webpack_require__("ai+R");
var groupedBarChart_style_default = /*#__PURE__*/__webpack_require__.n(groupedBarChart_style);

// CONCATENATED MODULE: ./components/projectDonutBarChart/donutBarChart/components/groupedBarChart/index.js


function groupedBarChart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function groupedBarChart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function groupedBarChart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var groupedBarChart_GroupedBarChart = function (_Component) {
	groupedBarChart__inherits(GroupedBarChart, _Component);

	function GroupedBarChart(props, context) {
		groupedBarChart__classCallCheck(this, GroupedBarChart);

		var _this = groupedBarChart__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.renderRow = function (item, index) {
			return Object(preact_min["h"])(barChartItem_ChartItem, {
				label1: _this.props.label1,
				label2: _this.props.label2,
				data: item.item,
				sdgIndex: _this.props.sdgIndex,
				index: index
			});
		};

		return _this;
	}

	GroupedBarChart.prototype.render = function render() {

		return Object(preact_min["h"])(
			'div',
			{ 'class': groupedBarChart_style_default.a.wrapper },
			Object(preact_min["h"])(
				'div',
				{ style: { border: '1px solid #ccc', borderRadius: '7px', padding: 25 }, 'class': groupedBarChart_style_default.a.list_wrapper },
				this.props.data && this.props.data.length ? Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						'div',
						{ 'class': groupedBarChart_style_default.a.legendOuterWrapper },
						Object(preact_min["h"])('div', { 'class': groupedBarChart_style_default.a.legendInnerWrapper })
					),
					Object(preact_min["h"])(listView["a" /* default */], {
						data: this.props.data,
						renderItem: this.renderRow
					})
				) : Object(preact_min["h"])(
					'span',
					{ 'class': groupedBarChart_style_default.a.noResults },
					'No Results'
				)
			)
		);
	};

	return GroupedBarChart;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ./components/budget-expense-legend/index.js
var budget_expense_legend = __webpack_require__("COsE");

// CONCATENATED MODULE: ./components/projectDonutBarChart/donutBarChart/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function donutBarChart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function donutBarChart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function donutBarChart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var donutBarChart__ref = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref2 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var _ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var _ref4 = Object(preact_min["h"])(budget_expense_legend["a" /* default */], null);

var _ref5 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var donutBarChart_DonutBarCharts = function (_Component) {
    donutBarChart__inherits(DonutBarCharts, _Component);

    function DonutBarCharts() {
        donutBarChart__classCallCheck(this, DonutBarCharts);

        return donutBarChart__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DonutBarCharts.prototype.render = function render() {

        if (this.props.barChartData.data) {
            if (this.props.barChartData.data.length > 0) {
                if (this.props.barChartData.data[0].sdg_code) {
                    this.props.barChartData.data = this.props.barChartData.data.map(function (element) {
                        var data = _extends({}, element, {
                            total_budgetNumber: parseFloat(element.total_budget)
                        });
                        return data;
                    });
                    var others = _.remove(this.props.barChartData.data, function (element) {
                        return element.sdg_code === "0";
                    });
                    var sortedArray = this.props.barChartData.data.sort(function (item1, item2) {
                        return item1.total_budgetNumber < item2.total_budgetNumber ? 1 : item2.total_budgetNumber < item1.total_budgetNumber ? -1 : 0;
                    });
                    others.length > 0 ? sortedArray.push(others[0]) : null;
                    this.props.barChartData.data = sortedArray;
                    ;
                }
            }
        }
        this.props.donutData.data;
        var donutDataArray = Array.isArray(this.props.donutData.data) ? this.props.donutData.data : [];

        this.props.sdg === 'true' && this.props.donutData.data ? this.props.donutData.data = donutDataArray.map(function (element) {
            return _extends({}, element, {
                budget: element.sdg_budget || element.budget_percentage
            });
        }) : this.props.donutData.data = donutDataArray.map(function (element) {
            return _extends({}, element, {
                budget: element.budget_percentage
            });
        });

        return Object(preact_min["h"])(
            'div',
            { 'class': style_default.a.wrapper },
            this.props.donutData.loading ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.preLoaderWrapper },
                donutBarChart__ref
            ) : this.props.donutData.data.length !== 0 ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.donutChartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.headerWrapper },
                    '% of Budget'
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.donuttopWrapper },
                    Object(preact_min["h"])(donutChart_DonutChart, {
                        sdg: this.props.sdg,
                        data: this.props.donutData.data,
                        legendData: [{}, {}],
                        chartWidth: 456,
                        chartHeight: 456,
                        chart_id: this.props.donutChartId,
                        sdgIndex: this.props.sdgIndex,
                        textFieldStyle: this.props.recipientProfile === 'true' ? style_default.a.recipientProfileChartHeaderInfo : this.props.textFieldSDGStyle ? this.props.textFieldSDGStyle : style_default.a.textFieldStyle,
                        textWrapperStyle: style_default.a.textWrapperStyle,
                        donor_wrapper_styles: style_default.a.donorWrapperStyle,
                        displayLegend: 'false',
                        displayRegularLegend: 'false'
                    })
                )
            ) : Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.noDataTemplateWrapper },
                _ref2
            ),
            this.props.barChartData.loading ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.preLoaderWrapper },
                _ref3
            ) : this.props.barChartData.data.length !== 0 ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.barChartWrapper },
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.headerWrapper },
                    'Budget - Expenditure',
                    _ref4
                ),
                Object(preact_min["h"])(groupedBarChart_GroupedBarChart, {
                    label1: 'Budget',
                    label2: 'Expenditure',
                    sdgIndex: this.props.sdgIndex,
                    data: this.props.barChartData.data
                })
            ) : Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.noDataTemplateWrapper },
                _ref5
            )
        );
    };

    return DonutBarCharts;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("FJnM");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./components/projectDescription/style.scss
var projectDescription_style = __webpack_require__("JNi8");
var projectDescription_style_default = /*#__PURE__*/__webpack_require__.n(projectDescription_style);

// CONCATENATED MODULE: ./components/projectDonutBarChart/index.js


function projectDonutBarChart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function projectDonutBarChart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function projectDonutBarChart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/************************* Preact Files ************************/



/************************* Custom Component Files ************************/


/************************* Third Party  Files ************************/


/************************* Style Files ************************/



var projectDonutBarChart__ref = Object(preact_min["h"])(preLoader["a" /* default */], null);

var projectDonutBarChart_ProjectDonut = function (_Component) {
	projectDonutBarChart__inherits(ProjectDonut, _Component);

	function ProjectDonut(props) {
		projectDonutBarChart__classCallCheck(this, ProjectDonut);

		var _this = projectDonutBarChart__possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentDidMount = function () {

			_this.props.fetchProjectProgramAreas(_this.props.projectId, _this.props.year);
		};

		_this.handleOnClick = function (e) {
			if (e.size && e.size != 1) {}
		};

		_this.onTargetClick = function (e) {

			if (e.name) {
				var targetIds = e.name.replace('Target', '').trim().split('.');
				window.location = '/programme-area/targets/' + targetIds[0] + '/' + targetIds[1];
			}
		};

		_this.onSDGClick = function (e) {
			return;
			if (e.parent.name.includes('PA')) {
				window.location = '/programme-area/' + e.parent.code + '/' + e.parent.fullName;
			}
		};

		return _this;
	}

	ProjectDonut.prototype.piechartData = function piechartData(resp) {
		resp.sdg.map(function (obj) {
			obj.fullName = obj.name;
			obj.name = 'Programme Area ' + obj.code;
			obj.image = '/static/assets/icons/sdg/PA-' + obj.code + '.svg';
		});
		var tempData = { name: '', size: 1 };
		tempData.children = resp.sdg;
		resp = tempData;
		return resp;
	};

	ProjectDonut.prototype.render = function render(props) {
		return Object(preact_min["h"])(
			'div',
			{ style: { margin: 'auto', maxWidth: '1200px' } },
			Object(preact_min["h"])(
				'div',
				{ style: { borderBottom: '1px solid rgb(204, 204, 204)', marginBottom: '70px' } },
				Object(preact_min["h"])(
					'span',
					{ style: { margin: '0' }, 'class': projectDescription_style_default.a.theme_slider_title },
					'Programme Areas'
				),
				this.props.projectDetail && this.props.projectDetail.programAreaBudget && this.props.projectDetail.programAreaBudget.data && this.props.projectDetail.programAreaBudget.data ? Object(preact_min["h"])(donutBarChart_DonutBarCharts, {
					donutData: this.props.projectDetail.programAreaBudget,
					donutChartId: 'budget_area',
					barChartData: this.props.projectDetail.programAreaBudget,
					sdg: 'true',
					recipientProfile: 'true'
				}) : Object(preact_min["h"])(
					'div',
					{ style: { position: 'relative', height: 344 } },
					projectDonutBarChart__ref
				)
			),
			Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'span',
					{ style: { marginLeft: '0' }, 'class': projectDescription_style_default.a.theme_slider_title },
					'SDG'
				),
				Object(preact_min["h"])(donutBarChart_DonutBarCharts, {
					donutData: this.props.projectDetail.projectSDGBudget,
					donutChartId: 'project_sdg_budget_area',
					barChartData: this.props.projectDetail.projectSDGBudget,
					sdg: 'true',
					recipientProfile: 'true',
					sdgIndex: this.props.sdgIndex
				})
			)
		);
	};

	return ProjectDonut;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
	var projectDetailMapData = state.mapData.projectDetailMapData;

	var mapCountryData = state.mapData;
	var sdg = state.sdgData;
	return {
		projectDetail: state.projectDetail,
		projectDetailMapData: projectDetailMapData,
		mapCountryData: mapCountryData,
		sdgIndex: sdg.data
	};
};

var projectDonutBarChart_mapDispatch = function mapDispatch(dispatch) {
	return {
		fetchProjectProgramAreas: function fetchProjectProgramAreas(id, year) {
			return dispatch(Object(projectDetailActions["c" /* fetchProjectProgramAreas */])(id, year));
		},
		fetchProjectDetailsOnSelection: function fetchProjectDetailsOnSelection(id) {
			return dispatch(Object(projectDetailActions["b" /* fetchProjectDetailsOnSelection */])(id));
		}
	};
};

/* harmony default export */ var projectDonutBarChart = __webpack_exports__["a"] = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps, projectDonutBarChart_mapDispatch)(projectDonutBarChart_ProjectDonut));

/***/ }),

/***/ "IQRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./components/commonHeader/index.js
var commonHeader = __webpack_require__("diX/");

// EXTERNAL MODULE: ./components/urlBreadCrumb/index.js
var urlBreadCrumb = __webpack_require__("v4O/");

// EXTERNAL MODULE: ./components/projectDescription/index.js
var projectDescription = __webpack_require__("Vhkl");

// EXTERNAL MODULE: ./components/budgetSource/index.js
var budgetSource = __webpack_require__("G9P3");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ./components/projectDetailTable/index.js + 5 modules
var projectDetailTable = __webpack_require__("V1bQ");

// EXTERNAL MODULE: ./components/projectTab/style.scss
var style = __webpack_require__("lKgI");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/projectDetailDocuTable/index.js
var projectDetailDocuTable = __webpack_require__("YTB6");

// EXTERNAL MODULE: ./components/purchaseOrderTable/index.js
var purchaseOrderTable = __webpack_require__("pqrH");

// EXTERNAL MODULE: ./static/assets/json/projectDetailOutPutResults.js
var projectDetailOutPutResults = __webpack_require__("QFwC");

// EXTERNAL MODULE: ./static/assets/json/projectDetailPurchaseOrderData.js
var projectDetailPurchaseOrderData = __webpack_require__("dIRi");

// EXTERNAL MODULE: ./static/assets/json/projectDetailDocuments.js
var projectDetailDocuments = __webpack_require__("CamH");

// EXTERNAL MODULE: ../node_modules/react-custom-scrollbars/lib/index.js
var lib = __webpack_require__("E5f5");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./components/projectTab/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var _ref = Object(preact_min["h"])(
    lib["Scrollbars"],
    null,
    Object(preact_min["h"])(projectDetailTable["a" /* default */], { data: projectDetailOutPutResults["a" /* projectDetailOutputResult */] })
);

var projectTab_ProjectTab = function (_Component) {
    _inherits(ProjectTab, _Component);

    function ProjectTab(props) {
        _classCallCheck(this, ProjectTab);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.componentWillReceiveProps = function (nextProps) {
            if (nextProps.projectDetail.document_list != _this.props.projectDetail.document_list) {
                _this.setState({
                    document_list: nextProps.projectDetail.document_list.data
                }, function () {});
            }
        };

        _this.tabClick = function (tab) {
            _this.setState({ tabSelected: tab }, function () {
                _this.props.onCurrentTabSelected(tab);
            });
        };

        _this.accordionClick = function (accordion) {
            if (_this.state.accordionSelected == accordion) {
                document.body.className = '';
                _this.setState({ accordionSelected: '' });
            } else {
                document.body.className = style_default.a.accordionScroll;
                _this.setState({ accordionSelected: accordion });
                _this.tabClick(accordion);
            }
        };

        _this.state = {
            tabSelected: 'Output/Results',
            accordionSelected: '',
            document_list: []
        };
        return _this;
    }

    ProjectTab.prototype.componentWillUnmount = function componentWillUnmount() {
        document.body.className = '';
    };

    ProjectTab.prototype.render = function render() {
        var _this2 = this;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.desktop },
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.tabSwitch },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': style_default.a.list },
                        Object(preact_min["h"])(
                            'li',
                            null,
                            Object(preact_min["h"])(
                                'button',
                                { 'class': this.state.tabSelected == "Output/Results" && style_default.a.active, onClick: function onClick(e) {
                                        return _this2.tabClick('Output/Results');
                                    } },
                                'CONTRACTS'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { style: { display: 'none' } },
                            Object(preact_min["h"])(
                                'button',
                                { 'class': this.state.tabSelected == "Documents" && style_default.a.active, onClick: function onClick(e) {
                                        return _this2.tabClick('Documents');
                                    } },
                                'DOCUMENTS'
                            )
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { style: { display: 'none' }, 'class': style_default.a.POWrapper },
                            Object(preact_min["h"])(
                                'button',
                                { 'class': this.state.tabSelected == "Purchase Order" && style_default.a.active, onClick: function onClick(e) {
                                        return _this2.tabClick('Purchase Order');
                                    } },
                                'PURCHASE ORDERS'
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': style_default.a.tooltipPO },
                                'A single Purchase Order (PO) can be issued to purchase goods or services for one or more projects. For those POs, the amount displayed is for one project only. Thus, there may be entries for less than USD 15,000, even though the total amount of that particular PO is actually more than USD 15,000. The balance amount will be displayed on other relevant project pages.'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.mobile },
                Object(preact_min["h"])(
                    'div',
                    { 'class': style_default.a.accordion },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': this.state.accordionSelected == "Output/Results" ? style_default.a.accordionItem + ' ' + style_default.a.accordionPosition : style_default.a.accordionItem },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': this.state.accordionSelected == "Output/Results" ? style_default.a.accordionTitle + ' ' + style_default.a.accordionSelected : style_default.a.accordionTitle, onClick: function onClick() {
                                    _this2.accordionClick('Output/Results');
                                } },
                            Object(preact_min["h"])(
                                'h3',
                                { 'class': style_default.a.accordionHead },
                                'Rewards / Results'
                            )
                        ),
                        this.state.accordionSelected == "Output/Results" ? Object(preact_min["h"])(
                            'div',
                            { 'class': style_default.a.accordionContent },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': style_default.a.scrollWrapper },
                                _ref
                            )
                        ) : null
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': this.state.accordionSelected == "Documents" ? style_default.a.accordionItem + ' ' + style_default.a.accordionPosition : style_default.a.accordionItem },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': this.state.accordionSelected == "Documents" ? style_default.a.accordionTitle + ' ' + style_default.a.accordionSelected : style_default.a.accordionTitle, onClick: function onClick() {
                                    _this2.accordionClick('Documents');
                                } },
                            Object(preact_min["h"])(
                                'h3',
                                { 'class': style_default.a.accordionHead },
                                'Documents'
                            )
                        ),
                        this.state.accordionSelected == "Documents" ? Object(preact_min["h"])(
                            'div',
                            { 'class': style_default.a.accordionContent },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': style_default.a.scrollWrapper },
                                Object(preact_min["h"])(
                                    lib["Scrollbars"],
                                    null,
                                    Object(preact_min["h"])(projectDetailDocuTable["a" /* default */], {
                                        clearFilter: function clearFilter() {
                                            return _this2.clearCategoryFilter();
                                        },
                                        loading: this.props.projectDetail.document_list_filtered.loading,
                                        categorySelect: function categorySelect(value) {
                                            return _this2.props.selectCategory(value);
                                        },
                                        data: this.props.document_list_filtered
                                    })
                                )
                            )
                        ) : null
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': this.state.accordionSelected == "Purchase Order" ? style_default.a.accordionItem + ' ' + style_default.a.accordionPosition : style_default.a.accordionItem },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': this.state.accordionSelected == "Purchase Order" ? style_default.a.accordionTitle + ' ' + style_default.a.accordionSelected : style_default.a.accordionTitle, onClick: function onClick() {
                                    _this2.accordionClick('Purchase Order');
                                } },
                            Object(preact_min["h"])(
                                'h3',
                                { 'class': style_default.a.accordionHead },
                                'Purchase Orders'
                            ),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': style_default.a.tooltipPO },
                                'A single Purchase Order (PO) can be issued to purchase goods or services for one or more projects. For those POs, the amount displayed is for one project only. Thus, there may be entries for less than USD 15,000, even though the total amount of that particular PO is actually more than USD 15,000. The balance amount will be displayed on other relevant project pages.'
                            )
                        ),
                        this.state.accordionSelected == "Purchase Order" ? Object(preact_min["h"])(
                            'div',
                            { 'class': style_default.a.accordionContent },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': style_default.a.scrollWrapper },
                                Object(preact_min["h"])(
                                    lib["Scrollbars"],
                                    null,
                                    Object(preact_min["h"])(purchaseOrderTable["a" /* default */], {
                                        loading: this.props.projectDetail.purchase_orders.loading,
                                        data: this.props.purchaseOrderData
                                    })
                                )
                            )
                        ) : null
                    )
                )
            )
        );
    };

    return ProjectTab;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    return {
        projectDetail: state.projectDetail
    };
};

var projectTab_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {};
};

/* harmony default export */ var projectTab = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps, projectTab_mapDispatchToProps)(projectTab_ProjectTab));
// EXTERNAL MODULE: ./components/PictureGallery/index.js
var PictureGallery = __webpack_require__("31tI");

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ./components/EmbedSection/index.js + 1 modules
var EmbedSection = __webpack_require__("7aq3");

// EXTERNAL MODULE: ./components/embedModal/index.js
var embedModal = __webpack_require__("xVFv");

// EXTERNAL MODULE: ./components/footer/index.js
var footer = __webpack_require__("5ttS");

// EXTERNAL MODULE: ./components/exportPopup/index.js
var exportPopup = __webpack_require__("s4wh");

// EXTERNAL MODULE: ./components/projectDonutBarChart/index.js + 4 modules
var projectDonutBarChart = __webpack_require__("Gnd3");

// EXTERNAL MODULE: ./utils/dateFormatter.js
var dateFormatter = __webpack_require__("GXBc");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/index.js
var projectDetailActions = __webpack_require__("csCp");

// EXTERNAL MODULE: ./shared/actions/mapActions/fetchMapOutputs.js
var fetchMapOutputs = __webpack_require__("GbIW");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/documentListActions.js
var documentListActions = __webpack_require__("e0UL");

// EXTERNAL MODULE: ./shared/actions/routerActions.js
var routerActions = __webpack_require__("Y9jh");

// EXTERNAL MODULE: ./components/urlBreadCrumb/data/actions.js
var actions = __webpack_require__("usUj");

// EXTERNAL MODULE: ./shared/actions/downLoadCSV.js
var downLoadCSV = __webpack_require__("+hMk");

// EXTERNAL MODULE: ../node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("FJnM");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./utils/commonActionUtils.js
var commonActionUtils = __webpack_require__("I9r4");

// EXTERNAL MODULE: ./routes/projectDetails/style.css
var projectDetails_style = __webpack_require__("pWm/");
var projectDetails_style_default = /*#__PURE__*/__webpack_require__.n(projectDetails_style);

// CONCATENATED MODULE: ../node_modules/babel-loader/lib??ref--0!./routes/projectDetails/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function projectDetails__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function projectDetails__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function projectDetails__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/************************* Preact Files ************************/



/************************* Custom Component Files ************************/

















/************************* Redux Action Files ************************/








/****************** Third Party Components  ********************/


/************************* util Files ************************/


/************************* Style Files ************************/


var projectDetails__ref = Object(preact_min["h"])(projectDetailTable["a" /* default */], null);

var _ref3 = Object(preact_min["h"])(footer["a" /* default */], null);

var projectDetails_ProjectDetails = function (_Component) {
	projectDetails__inherits(ProjectDetails, _Component);

	// ------------------------ Embed section methods  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
	ProjectDetails.prototype.setPageHeader = function setPageHeader(projectId) {
		var title = projectId ? projectId : '';
		this.props.onChangeRoute(title);
		this.props.setPageHeader({
			title: title,
			breadcrumb: [{
				id: 1,
				title: 'Home',
				link: '/'
			}, {
				id: 1,
				title: 'Projects',
				link: '/projects'
			}, {
				id: 2,
				title: title
			}]
		});
		this.setState({
			pageTitle: '' + title
		});
	};

	// -------------------------------------------->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>


	function ProjectDetails(props) {
		projectDetails__classCallCheck(this, ProjectDetails);

		var _this = projectDetails__possibleConstructorReturn(this, _Component.call(this, props));

		_this.createCheckList = function (callbk) {
			var newUrl = _this.state.baseUrl;
			_this.state.checkList.forEach(function (item, index) {
				if (index === 0) {
					newUrl = newUrl + item.key + '=' + item.flag;
				} else {
					newUrl = newUrl + '&' + item.key + '=' + item.flag;
				}
			});
			_this.setState({
				selectionListUrl: newUrl
			}, function () {
				if (callbk !== undefined) {
					callbk();
				}
			});
		};

		_this.openEmbedModal = function () {
			_this.createCheckList(_this.setState({
				displayEmbedModal: true
			}));
		};

		_this.handleClose = function () {
			_this.setState({ displayEmbedModal: false }, function () {
				_this.clearSelect();
			});
		};

		_this.handleOnSelect = function (e, data) {
			var selectedList = _this.state.checkList.map(function (item) {
				return item.key === data.key ? {
					flag: e.target.checked,
					label: item.label,
					key: item.key
				} : item;
			});
			_this.setState({
				checkList: selectedList
			}, function () {
				_this.createCheckList();
			});
		};

		_this.clearSelect = function () {
			var clearedList = _this.state.checkList.map(function (item) {
				return {
					flag: _this.initialChecklist[item.key],
					label: item.label,
					key: item.key
				};
			});

			_this.setState({
				checkList: clearedList
			});
		};

		_this.onCurrentTabSelected = function (currentTab) {
			_this.setState({ currentTab: currentTab });
			if (currentTab === 'Documents') {
				_this.props.swapDocumentList();
			}
		};

		_this.selectCategory = function (category) {
			_this.setState({ projectDocCategory: category });
			category === '' ? _this.props.swapDocumentList() : _this.props.updateProjectDocumentList(_this.state.projectId, category);
		};

		_this.getSearchParam = function (param) {
			_this.docSearchParam = param;
		};

		_this.switchTableOnTabSelect = function (currentTab) {
			var rendertable = projectDetails__ref;
			switch (currentTab) {
				case 'Output/Results':
					rendertable = Object(preact_min["h"])(projectDetailTable["a" /* default */], {
						loading: _this.props.projectDetail.output_list.loading
					});
					break;
				case 'Documents':
					rendertable = Object(preact_min["h"])(projectDetailDocuTable["a" /* default */], {
						getSearchParam: _this.getSearchParam,
						loading: _this.props.projectDetail.document_list_filtered.loading,
						categorySelect: function categorySelect(value) {
							return _this.selectCategory(value);
						},

						data: _this.props.projectDetail && _this.props.projectDetail.document_list_filtered && _this.props.projectDetail.document_list_filtered.data ? _this.props.projectDetail.document_list_filtered.data : []
					});
					break;
				case 'Purchase Order':
					rendertable = Object(preact_min["h"])(purchaseOrderTable["a" /* default */], {
						loading: _this.props.projectDetail.purchase_orders.loading,
						data: _this.props.projectDetail && _this.props.projectDetail.purchase_orders && _this.props.projectDetail.purchase_orders.data ? _this.props.projectDetail.purchase_orders.data : []
					});
					break;
				default:
					rendertable = null;
			}
			return rendertable;
		};

		_this.componentDidMount = function () {
			var year = _this.props.mapCurrentYear;
			window.scrollTo(0, 0);
			_this.props.loadOutputsMapData(_this.props.mapCurrentYear, '', '', '', _this.props.id, '');
			_this.setPageHeader();
			window.scrollTo(0, 0);
		};

		_this.componentWillReceiveProps = function (nextProps) {
			var id = nextProps.id;

			if (nextProps.projectDetail && nextProps.projectDetail.project && nextProps.projectDetail.project.title) {
				if (id === nextProps.projectDetail.project.project_id && !_this.state.flag) {
					_this.setState(_extends({}, _this.state, {
						projectId: id,
						projectTitle: nextProps.projectDetail.project.title,
						flag: true
					}), function () {
						_this.setPageHeader(_this.state.projectTitle);
					});
				}
			}
		};

		_this.openEmbedModal = function () {
			_this.createCheckList(_this.setState({
				displayEmbedModal: true
			}));
		};

		_this.handleClose = function () {
			_this.setState({ displayEmbedModal: false }, function () {
				_this.clearSelect();
			});
		};

		_this.showExportModal = function () {
			_this.setState({
				showExportModal: true
			});
		};

		_this.state = {
			currentTab: 'Output/Results',
			projectId: '',
			projectTitle: '',
			flag: false,
			showMore: false,
			selectionListUrl: window.location.origin + '/embed/projects/' + _this.props.id + '?',
			baseUrl: window.location.origin + '/embed/projects/' + _this.props.id + '?',
			projectDocCategory: '',
			pageTitle: '',
			checkList: _this.props.id.toString() === '00094616' ? [{
				flag: true,
				label: 'Title',
				key: 'title'
			}, {
				flag: true,
				label: 'Description',
				key: 'description'
			}, {
				flag: true,
				label: 'Map',
				key: 'map'
			}, {
				flag: false,
				label: 'Satellite',
				key: 'satellite'
			}, {
				flag: false,
				label: 'Project Info',
				key: 'projectinfo'
			}, {
				flag: false,
				label: 'Donors',
				key: 'budgetSources'
			}, {
				flag: false,
				label: 'Outputs / Results',
				key: 'outputTable'
			}, {
				flag: false,
				label: 'Documents',
				key: 'docTable'
			}, {
				flag: false,
				label: 'Purchase Orders',
				key: 'purchaseOrdrTable'
			}] : [{
				flag: true,
				label: 'Title',
				key: 'title'
			}, {
				flag: true,
				label: 'Description',
				key: 'description'
			}, {
				flag: true,
				label: 'Map',
				key: 'map'
			}, {
				flag: false,
				label: 'Project Info',
				key: 'projectinfo'
			}, {
				flag: false,
				label: 'Donors',
				key: 'budgetSources'
			}, {
				flag: false,
				label: 'Outputs / Results',
				key: 'outputTable'
			}, {
				flag: false,
				label: 'Documents',
				key: 'docTable'
			}, {
				flag: false,
				label: 'Purchase Orders',
				key: 'purchaseOrdrTable'
			}],
			displayEmbedModal: false,
			showExportModal: false
		};
		_this.docSearchParam = '';

		_this.initialChecklist = {
			title: true,
			description: true,
			map: true,
			projectinfo: false,
			outputTable: false,
			docTable: false,
			purchaseOrdrTable: false,
			budgetSources: false
		};
		return _this;
	}

	ProjectDetails.prototype.componentWillMount = function componentWillMount() {
		this.props.clearProjectDetails();
		var url = window.location.href,
		    id = url.substring(url.lastIndexOf('/') + 1);
		this.props.fetchProjectDetailsOnSelection(id);
		this.createCheckList();
	};

	ProjectDetails.prototype.hideExportModal = function hideExportModal() {
		this.setState({ showExportModal: false });
	};

	ProjectDetails.prototype.getThemeAggregate = function getThemeAggregate(themeData) {
		var themeDataList = [];
		var total_value = 0;
		if (themeData) {
			themeData.map(function (value, index) {
				total_value = total_value + value.size.budget;
				var themeObject = {
					"sector": value.code,
					"sdg_name": value.fullName,
					"sdg_color": value.color,
					"sdg_budget": value.size.budget,
					"sdg_expense": value.size.expense,
					"percentage": value.size.percentage
				};
				themeDataList.push(themeObject);
			});
		}
		return [themeDataList, total_value];
	};

	ProjectDetails.prototype.paAggregate = function paAggregate(data) {
		var total = 0;
		if (data.length !== 0) {
			data.forEach(function (element) {
				total = total + element.budget;
			});
		}
		return total;
	};

	ProjectDetails.prototype.renderExportPopup = function renderExportPopup() {
		var _this2 = this;

		var data = void 0,
		    loading = void 0,
		    templateType = void 0;
		var hash = new Map();
		this.props.projectDetail && this.props.projectDetail.budget_utilization && this.props.projectDetail.budget_utilization.budget_data && this.props.projectDetail.budget_utilization.budget_data.concat(this.props.projectDetail.budget_utilization.expense_data).forEach(function (obj) {
			hash.set(obj.year, _extends(hash.get(obj.year) || {}, obj));
		});

		var projectId = this.props.projectDetail.project.project_id,
		    item = "",
		    search = "",
		    category = "",
		    fileName = "";

		switch (this.state.currentTab) {
			case 'Output/Results':
				item = 1;
				fileName = "output_results.csv";
				break;
			case 'Documents':
				item = 2;
				category = this.state.projectDocCategory;
				search = this.docSearchParam;
				fileName = "documents.csv";
				break;
			case 'Purchase Order':
				item = 3;
				fileName = "purchase_orders.csv";
				break;
			default:
				break;
		}

		var budget_utilization_merged = Array.from(hash.values());
		// Project TimeLine Calculation
		var start = new Date(this.props.projectDetail.time_line.start_date),
		    end = new Date(this.props.projectDetail.time_line.end_date),
		    today = new Date(),
		    timeline_completed = Math.round((today - start) / (end - start) * 100),
		    time_line = {
			start_date: Object(dateFormatter["a" /* getFormmattedDate */])(this.props.projectDetail.time_line.start_date),
			end_date: Object(dateFormatter["a" /* getFormmattedDate */])(this.props.projectDetail.time_line.end_date),
			timeline_completed: timeline_completed
		};
		var paList = this.getThemeAggregate(this.props.projectDetail && this.props.projectDetail.programAreaBudget && this.props.projectDetail.programAreaBudget.data && this.props.projectDetail.programAreaBudget.data.sdg);
		data = {
			year: this.props.mapCurrentYear,
			project_id: this.props.projectDetail.project.project_id,
			time_line: time_line,
			purchase_orders: this.props.projectDetail.purchase_orders.data,
			project: this.props.projectDetail.project,
			budget_source: this.props.projectDetail.budget_source,
			budget_utilization: budget_utilization_merged,
			document_list: this.props.projectDetail.document_list.data,
			output_list: this.props.projectDetail.output_list.data,
			mapData: this.props.outputData.data,
			title: this.props.projectDetail.project.title,
			sdgDetail: this.props.projectDetail.projectSDGBudget.data,
			paDetail: paList[0],
			paAggregate: paList[1],
			sdgAggregate: this.paAggregate(this.props.projectDetail.projectSDGBudget.data),
			lastUpdatedDate: Object(dateFormatter["a" /* getFormmattedDate */])(this.props.lastUpdatedDate.data.last_updated_date)
		};

		loading = this.props.projectDetail.loading || this.props.outputData.loading;

		templateType = 'projects_selected';

		return Object(preact_min["h"])(exportPopup["a" /* default */], {
			templateType: templateType,
			data: data,
			loading: loading,
			onCloseModal: function onCloseModal() {
				return _this2.hideExportModal();
			},
			downloadCsv: function downloadCsv() {
				_this2.props.downLoadProjectDetailsCsv(projectId, item, search, category, fileName);
			},
			type: 'projectDetails'
		});
	};

	ProjectDetails.prototype.render = function render(_ref2, state) {
		var _this3 = this;

		var router = _ref2.router,
		    projectDetail = _ref2.projectDetail,
		    projectDetailsMapData = _ref2.projectDetailsMapData;


		var title = this.state.pageTitle;
		var satelliteData = !projectDetail.loading && projectDetail.project ? projectDetail.project.storyMap : [];

		return Object(preact_min["h"])(
			'div',
			{ 'class': projectDetails_style_default.a.wrapper },
			this.state.showExportModal ? this.renderExportPopup() : null,
			Object(preact_min["h"])(Helmet_default.a, { title: title,
				meta: [{ property: 'og:title', content: title }, { property: 'twitter:title', content: title }]
			}),
			Object(preact_min["h"])(commonHeader["a" /* default */], { title: title, active: 'projects', showExportModal: this.showExportModal, enableSearch: true, onClickEmbed: this.openEmbedModal, enableBanner: false, disableDropdown: false }),
			Object(preact_min["h"])(
				'div',
				{ 'class': projectDetails_style_default.a.projectSection },
				Object(preact_min["h"])(projectDescription["a" /* default */], { satelliteData: satelliteData, projectId: this.props.id }),
				Object(preact_min["h"])(budgetSource["a" /* default */], { data: this.props.projectDetail.budget_source }),
				Object(preact_min["h"])(projectDonutBarChart["a" /* default */], { projectId: this.props.id, year: this.props.mapCurrentYear })
			),
			window.location.host != "open.iucn.org" ? Object(preact_min["h"])(
				'div',
				{ 'class': projectDetails_style_default.a.deliveryModelComponentWrapper },
				Object(preact_min["h"])(
					'div',
					{ 'class': projectDetails_style_default.a.deliveryModelWrapper },
					Object(preact_min["h"])(
						'p',
						{ 'class': projectDetails_style_default.a.deliveryModelHeading },
						'Delivery Model'
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': projectDetails_style_default.a.deliveryModelProjectWrapper },
						Object(preact_min["h"])(
							'span',
							null,
							' ',
							this.props.projectDetail.project.delivery_model && this.props.projectDetail.project.delivery_model.delivery_model_name
						)
					)
				)
			) : "",
			Object(preact_min["h"])(
				'div',
				{ 'class': projectDetails_style_default.a.projectTablesection },
				Object(preact_min["h"])(projectTab, { selectCategory: function selectCategory(value) {
						return _this3.selectCategory(value);
					},
					purchaseOrderData: this.props.projectDetail && this.props.projectDetail.purchase_orders ? this.props.projectDetail.purchase_orders.data : [],
					document_list_filtered: this.props.projectDetail && this.props.projectDetail.document_list_filtered ? this.props.projectDetail.document_list_filtered.data : [],
					onCurrentTabSelected: function onCurrentTabSelected(currentTab) {
						return _this3.onCurrentTabSelected(currentTab);
					}
				}),
				Object(preact_min["h"])(
					'div',
					{ 'class': projectDetails_style_default.a.desktopTable },
					this.switchTableOnTabSelect(this.state.currentTab)
				)
			),
			Object(preact_min["h"])(embedModal["a" /* default */], {
				display: this.state.displayEmbedModal,
				checkList: this.state.checkList,
				modifiedUrl: this.state.selectionListUrl + '&projectCat=' + this.state.projectDocCategory,
				handleClose: this.handleClose,
				getselectedItem: this.getselectedItem,
				handleOnSelect: this.handleOnSelect
			}),
			_ref3
		);
	};

	return ProjectDetails;
}(preact_min["Component"]);

var projectDetails_mapStateToProps = function mapStateToProps(state) {
	return {
		router: state.router,
		projectDetail: state.projectDetail,
		projectDetailMapData: state.mapData.projectDetailMapData,
		outputData: state.mapData.outputData,
		mapCurrentYear: state.mapData.yearTimeline.mapCurrentYear,
		lastUpdatedDate: state.lastUpdatedDate
	};
};

var projectDetails_mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		setPageHeader: function setPageHeader(data) {
			return dispatch(Object(actions["a" /* setPageHeader */])(data));
		},
		fetchProjectDetailsOnSelection: function fetchProjectDetailsOnSelection(id) {
			return dispatch(Object(projectDetailActions["b" /* fetchProjectDetailsOnSelection */])(id));
		},
		clearProjectDetails: function clearProjectDetails() {
			return dispatch(Object(projectDetailActions["a" /* clearProjectDetails */])());
		},
		updateProjectDocumentList: function updateProjectDocumentList(id, category) {
			return dispatch(Object(documentListActions["e" /* updateProjectDocumentList */])(id, category));
		},
		swapDocumentList: function swapDocumentList() {
			return dispatch(Object(documentListActions["d" /* swapDocumentList */])());
		},
		onChangeRoute: function onChangeRoute(title) {
			return dispatch(Object(routerActions["b" /* onChangeRoute */])(title));
		},
		loadOutputsMapData: function loadOutputsMapData(year, unit, sector, source, projectId, budgetType) {
			return dispatch(Object(fetchMapOutputs["d" /* loadOutputsMapData */])(year, unit, sector, source, projectId, budgetType));
		},
		downLoadProjectDetailsCsv: function downLoadProjectDetailsCsv(projectId, item, search, category, fileName) {
			return dispatch(Object(downLoadCSV["c" /* downLoadProjectDetailsCsv */])(projectId, item, search, category, fileName));
		}

	};
};

/* harmony default export */ var projectDetails = __webpack_exports__["default"] = (Object(preact_redux_esm["a" /* connect */])(projectDetails_mapStateToProps, projectDetails_mapDispatchToProps)(projectDetails_ProjectDetails));

/***/ }),

/***/ "JNi8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2ChvU","descriptionSection":"descriptionSection__2bhUb","description":"description__3dtic","mapArea":"mapArea__qjRGI","timelineNew":"timelineNew__2icBA","heading":"heading__YLXD5","source":"source__1w4Qs","mapOptions":"mapOptions__pWIIx","mapMenu":"mapMenu__18qMN","mapbuttons":"mapbuttons__3MF8q","selected":"selected__1pvrx","expandButton":"expandButton__1W7Hq","theme_slider_title":"theme_slider_title__1qsrU","projectStatus":"projectStatus__3c0BB","hide":"hide__2HtCo","expanded":"expanded__1XCXM","projectMap":"projectMap__2l2vw","satellite":"satellite__ZSJDd","disclaimer":"disclaimer__1Br-b","arealChart":"arealChart__3N4bJ","areaHeaderWrapper":"areaHeaderWrapper__3_jzG","titleWrapper":"titleWrapper__18Opn","legendWrapper":"legendWrapper__1clp7","legendItemOuterWrapper":"legendItemOuterWrapper__SAhx2","legendItemInnerWrapper":"legendItemInnerWrapper__3FfdE","itemAlignmentWrapper":"itemAlignmentWrapper__1uT-o","legend":"legend__12-Gc","budgetLegend":"budgetLegend__1lDSb","revenueLegend":"revenueLegend__16o4P","info":"info__3wKex","info_popup":"info_popup__lfafR","projectTopoIconsLegend":"projectTopoIconsLegend__3O5XD","accordion__arrow__left":"accordion__arrow__left__1GY5z","accordion__arrow__right":"accordion__arrow__right__23E1P","locationText":"locationText__3afVw","satellite_btn_container":"satellite_btn_container__sWzwY","rightBtn":"rightBtn__3Lmnb","leftBtn":"leftBtn__386-N","centerBtn":"centerBtn__3BLJv","satelliteWrapper":"satelliteWrapper__1XBoA","buttonMode":"buttonMode__k7Whe","cssCircle":"cssCircle__rNdac","cssCirclePartner":"cssCirclePartner__w6Wyo","minusSign":"minusSign__28dEc","plusSign":"plusSign__1pY9G","sunburstParent":"sunburstParent__u019t","sunburstChartContainer":"sunburstChartContainer__1afU2"};

/***/ }),

/***/ "O8Wv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var detectPassiveEvents = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      var passive = false;
      var options = Object.defineProperty({}, 'passive', {
        get: function get() {
          passive = true;
        }
      });
      // note: have to set and remove a no-op listener instead of null
      // (which was used previously), becasue Edge v15 throws an error
      // when providing a null callback.
      // https://github.com/rafrex/detect-passive-events/pull/3
      var noop = function noop() {};
      window.addEventListener('testPassiveEventSupport', noop, options);
      window.removeEventListener('testPassiveEventSupport', noop, options);
      detectPassiveEvents.hasSupport = passive;
    }
  }
};

detectPassiveEvents.update();
exports.default = detectPassiveEvents;

/***/ }),

/***/ "OXGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectimeline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dateFormatter__ = __webpack_require__("GXBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__("YZJ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var projectimeline = function (_Component) {
  _inherits(projectimeline, _Component);

  function projectimeline(props, context) {
    _classCallCheck(this, projectimeline);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.setPercentCompleted = function () {
      var perc = _this.calculatePerc() + "%";
      _this.setState({ perc: perc });
    };

    _this.calculatePerc = function () {
      if (_this.isProjectTimeLineNonEmpty) {
        var start = new Date(_this.state.data.start_date),
            end = new Date(_this.state.data.end_date),
            today = new Date(),
            p = Math.round((today - start) / (end - start) * 100);
        return p;
      }
    };

    _this.state = {
      data: _this.props.data ? _this.props.data : {},
      perc: 0
    }, _this.isProjectTimeLineNonEmpty = _this.props.data && Object.keys(_this.props.data).length > 0;
    return _this;
  }

  projectimeline.prototype.componentWillMount = function componentWillMount() {
    this.setPercentCompleted();
  };

  projectimeline.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (nextProps.data != this.props.data) {
      this.isProjectTimeLineNonEmpty = nextProps.data && Object.keys(nextProps.data).length > 0;
      this.setState({
        data: nextProps.data
      }, function () {
        return _this2.setPercentCompleted();
      });
    }
  };

  projectimeline.prototype.render = function render() {
    if (this.isProjectTimeLineNonEmpty) {
      var length = this.state.data.year_array.length,
          start_year = this.state.data.year_array[0],
          end_year = this.state.data.year_array[length - 1],
          divisions = end_year - start_year,
          width_factor = 100 / divisions,
          list = [];
      for (var i = start_year; i <= end_year; i++) {
        list.push(i);
      };
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'section',
      null,
      this.isProjectTimeLineNonEmpty && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'section',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'p',
          { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.headingTimeline },
          'Project Timeline'
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.timeLineWrapper },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.progressBar },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.progressBarChild, style: { width: this.state.perc } }),
            list.map(function (el, index) {
              var width_percentage = {
                left: index * width_factor + '%'
              };
              return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.bar_step, style: width_percentage },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'div',
                  { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.label_percent },
                  el
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.label_line })
              );
            })
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.dateWrapper },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'span',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_1__utils_dateFormatter__["a" /* getFormmattedDate */])(this.state.data.start_date)
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'span',
              null,
              Object(__WEBPACK_IMPORTED_MODULE_1__utils_dateFormatter__["a" /* getFormmattedDate */])(this.state.data.end_date)
            )
          )
        )
      )
    );
  };

  return projectimeline;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "QFwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projectDetailOutputResult; });
var projectDetailOutputResult = [{
    id: '000954595',
    output: 'OutputName',
    theme: 'Democratice governance',
    outputDesc: 'Updated legislative policy and regulatory framework',
    viewDetails: 'View Results'

}, {
    id: '000954596',
    output: 'OutputName',
    theme: 'Responsive institution',
    outputDesc: 'Updated legislative policy and regulatory framework',
    viewDetails: 'View Results'

}, {
    id: '000954597',
    output: 'OutputName',
    theme: 'Democratice governance',
    outputDesc: 'Updated legislative policy and regulatory framework',
    viewDetails: 'View Results'

}, {
    id: '000954598',
    output: 'OutputName',
    theme: 'Responsive institution',
    outputDesc: 'Updated legislative policy and regulatory framework',
    viewDetails: 'View Results'

}];

/***/ }),

/***/ "V1bQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/projectDetailTable/style.scss
var style = __webpack_require__("/NpY");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/react-bootstrap-table/lib/index.js
var lib = __webpack_require__("X5Y7");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./components/preLoader/index.js
var preLoader = __webpack_require__("ufjx");

// EXTERNAL MODULE: ./components/projectDetailTable/component/style.scss
var component_style = __webpack_require__("4VU6");
var component_style_default = /*#__PURE__*/__webpack_require__.n(component_style);

// EXTERNAL MODULE: ./utils/numberFormatter.js
var numberFormatter = __webpack_require__("Au7/");

// EXTERNAL MODULE: ../node_modules/react-custom-scrollbars/lib/index.js
var react_custom_scrollbars_lib = __webpack_require__("E5f5");
var react_custom_scrollbars_lib_default = /*#__PURE__*/__webpack_require__.n(react_custom_scrollbars_lib);

// CONCATENATED MODULE: ./components/projectDetailTable/component/outputResults.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref3 = Object(preact_min["h"])(
    'h4',
    null,
    'Indicators'
);

var _ref4 = Object(preact_min["h"])(
    'h4',
    null,
    'Baseline'
);

var _ref5 = Object(preact_min["h"])(
    'h4',
    null,
    'Target'
);

var _ref6 = Object(preact_min["h"])(
    'h4',
    null,
    'Result'
);

var _ref7 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var outputResults_OutputResults = function (_Component) {
    _inherits(OutputResults, _Component);

    function OutputResults(props) {
        _classCallCheck(this, OutputResults);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.switchBtn = function (year) {
            var activeOutput = _this.output.filter(function (item, index) {
                return item.year == year;
            });
            _this.setState({ activeYear: year, activeOutput: activeOutput[0] });
        };

        _this.state = {
            yearSpan: [],
            activeYear: null,
            activeOutput: {
                target: [],
                actual: []
            }
        };
        return _this;
    }

    OutputResults.prototype.parseData = function parseData(modalData) {
        this.output = modalData.result_periods.map(function (item, index) {
            return {
                year: new Date(item.period_start).getFullYear(),
                actual: item.actual != null ? item.actual.split('\n') : '',
                target: item.target != null ? item.target.split('\n') : ''
            };
        });
        this.setState({
            yearSpan: modalData.result_period_span,
            activeYear: modalData.result_period_span[0],
            activeOutput: this.output[0]
        });
    };

    OutputResults.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        nextProps.data && this.parseData(nextProps.data);
    };

    OutputResults.prototype.componentDidMount = function componentDidMount() {
        this.props.data && this.parseData(this.props.data);
    };

    OutputResults.prototype.render = function render(_ref, _ref2) {
        var _this2 = this;

        var data = _ref.data;
        var yearSpan = _ref2.yearSpan,
            activeYear = _ref2.activeYear,
            activeOutput = _ref2.activeOutput;

        var indicators = data && data.indicator_description ? data.indicator_description.split('\n') : [];
        var baseline = data && data.baseline_comment ? data.baseline_comment.split('\n') : [];
        return Object(preact_min["h"])(
            'div',
            { 'class': component_style_default.a.modal },
            Object(preact_min["h"])(
                'section',
                { className: component_style_default.a.outerContainer },
                Object(preact_min["h"])(
                    'div',
                    { className: component_style_default.a.modalContainer },
                    Object(preact_min["h"])(
                        'header',
                        { 'class': component_style_default.a.headerWrapper },
                        Object(preact_min["h"])(
                            'h3',
                            { className: component_style_default.a.resultsHeader },
                            'Results'
                        ),
                        Object(preact_min["h"])('span', { className: component_style_default.a.closeBtn, onClick: function onClick() {
                                return _this2.props.onCloseModal();
                            } })
                    ),
                    this.props.data ? Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.modalContent },
                        Object(preact_min["h"])(
                            react_custom_scrollbars_lib["Scrollbars"],
                            null,
                            Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.desktop },
                                Object(preact_min["h"])(
                                    'section',
                                    { className: component_style_default.a.yearWrapper },
                                    this.state.yearSpan.map(function (year, index) {
                                        return Object(preact_min["h"])(
                                            'button',
                                            { className: component_style_default.a.yearBtn + ' ' + (year == activeYear ? component_style_default.a.activeYear : ''),
                                                onClick: function onClick() {
                                                    _this2.switchBtn(year);
                                                } },
                                            year
                                        );
                                    })
                                )
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': component_style_default.a.results_container },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.results_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.results_container_wrapper },
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.detailWrapper },
                                            Object(preact_min["h"])(
                                                'div',
                                                { 'class': component_style_default.a.topHeading },
                                                _ref3
                                            ),
                                            Object(preact_min["h"])(
                                                'ul',
                                                { 'class': component_style_default.a.detailsSection },
                                                indicators.length > 0 ? indicators.map(function (item, indexItem) {
                                                    return Object(preact_min["h"])(
                                                        'li',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'span',
                                                            { 'class': component_style_default.a.textValue },
                                                            item
                                                        )
                                                    );
                                                }) : Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': component_style_default.a.textValue },
                                                    'No data available'
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.detailWrapper },
                                            Object(preact_min["h"])(
                                                'div',
                                                { 'class': component_style_default.a.topHeading },
                                                _ref4
                                            ),
                                            Object(preact_min["h"])(
                                                'ul',
                                                { 'class': component_style_default.a.detailsSection },
                                                baseline.length > 0 ? baseline.map(function (item, indexItem) {
                                                    return Object(preact_min["h"])(
                                                        'li',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'span',
                                                            { 'class': component_style_default.a.textValue },
                                                            item
                                                        )
                                                    );
                                                }) : Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': component_style_default.a.textValue },
                                                    'No data available'
                                                )
                                            )
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.results_item },
                                    Object(preact_min["h"])(
                                        'section',
                                        { 'class': component_style_default.a.mobile },
                                        Object(preact_min["h"])(
                                            'section',
                                            { className: component_style_default.a.yearWrapper },
                                            this.state.yearSpan.map(function (year, index) {
                                                return Object(preact_min["h"])(
                                                    'button',
                                                    { className: component_style_default.a.yearBtn + ' ' + (year == activeYear ? component_style_default.a.activeYear : ''),
                                                        onClick: function onClick() {
                                                            _this2.switchBtn(year);
                                                        } },
                                                    year
                                                );
                                            })
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'footer',
                                        { className: component_style_default.a.footerContainer },
                                        Object(preact_min["h"])(
                                            'div',
                                            { className: component_style_default.a.footerDataWrapper },
                                            _ref5,
                                            Object(preact_min["h"])(
                                                'ul',
                                                { 'class': component_style_default.a.detailsSection },
                                                activeOutput.target.length > 0 ? activeOutput.target.map(function (item, indexItem) {
                                                    return Object(preact_min["h"])(
                                                        'li',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'span',
                                                            { 'class': component_style_default.a.textValue },
                                                            item
                                                        )
                                                    );
                                                }) : Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': component_style_default.a.textValue },
                                                    'No data available'
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'div',
                                            { className: component_style_default.a.footerDataWrapper },
                                            _ref6,
                                            Object(preact_min["h"])(
                                                'ul',
                                                { 'class': component_style_default.a.detailsSection },
                                                activeOutput.actual.length > 0 ? activeOutput.actual.map(function (item, indexItem) {
                                                    return Object(preact_min["h"])(
                                                        'li',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'span',
                                                            { 'class': component_style_default.a.textValue },
                                                            item
                                                        )
                                                    );
                                                }) : Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': component_style_default.a.textValue },
                                                    'No data available'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ) : Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.preloaderWrapper },
                        _ref7
                    )
                )
            )
        );
    };

    return OutputResults;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ./static/assets/json/undpAboutUsData.js
var undpAboutUsData = __webpack_require__("gglo");

// CONCATENATED MODULE: ./components/projectDetailTable/component/expandableRow.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function expandableRow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function expandableRow__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function expandableRow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var expandableRow_ScrollSection = function (_Component) {
    expandableRow__inherits(ScrollSection, _Component);

    function ScrollSection() {
        expandableRow__classCallCheck(this, ScrollSection);

        var _this = expandableRow__possibleConstructorReturn(this, _Component.call(this));

        _this.renderSubLevels = function (data) {
            var sectionData = data.map(function (subdata, index) {
                if (typeof subdata.sublevel !== 'undefined') {
                    return Object(preact_min["h"])(
                        'ul',
                        { key: index, 'class': component_style_default.a.sub_section_container },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': component_style_default.a.sub_header },
                            subdata.title
                        ),
                        _this.renderSubLevels(subdata.sublevel)
                    );
                } else {
                    return Object(preact_min["h"])(
                        'li',
                        { 'class': component_style_default.a.sub_section, key: subdata.title + index },
                        Object(preact_min["h"])('img', { src: '/static/assets/icons/bullets.svg', alt: '\\2022', 'class': component_style_default.a.bullet }),
                        subdata.title
                    );
                }
            });
            return sectionData;
        };

        _this.state = {
            overflow: false
        };
        return _this;
    }

    ScrollSection.prototype.componentDidMount = function componentDidMount() {
        if (this['sublevelWrapper' + this.props.index].clientHeight > 145) {
            this.setState({ overflow: true });
        }
    };

    ScrollSection.prototype.renderVerticalTrack = function renderVerticalTrack(props) {
        if (this.state.overflow) {
            return Object(preact_min["h"])('section', _extends({}, props, { 'class': component_style_default.a.track_vertical }));
        } else {
            return Object(preact_min["h"])('section', props);
        }
    };

    ScrollSection.prototype.render = function render() {
        var _this2 = this;

        return Object(preact_min["h"])(
            react_custom_scrollbars_lib["Scrollbars"],
            { 'class': component_style_default.a.sub_level,
                renderTrackVertical: function renderTrackVertical(props) {
                    return _this2.renderVerticalTrack(props);
                },
                renderThumbVertical: function renderThumbVertical(props) {
                    return Object(preact_min["h"])('section', _extends({}, props, { 'class': component_style_default.a.thumb_vertical }));
                },
                renderThumbHorizontal: function renderThumbHorizontal(props) {
                    return Object(preact_min["h"])('section', _extends({}, props, { 'class': component_style_default.a.thumb_horizontal }));
                }
            },
            Object(preact_min["h"])(
                'section',
                { ref: function ref(refs) {
                        return _this2['sublevelWrapper' + _this2.props.index] = refs;
                    } },
                this.renderSubLevels(this.props.marker.sublevel)
            )
        );
    };

    return ScrollSection;
}(preact_min["Component"]);

var expandableRow_ExpandableRow = function (_Component2) {
    expandableRow__inherits(ExpandableRow, _Component2);

    function ExpandableRow(props) {
        expandableRow__classCallCheck(this, ExpandableRow);

        var _this3 = expandableRow__possibleConstructorReturn(this, _Component2.call(this, props));

        _this3.cellTextItem = function (data) {
            return Object(preact_min["h"])(
                'div',
                { 'class': component_style_default.a.cellElement },
                Object(preact_min["h"])('span', { 'class': component_style_default.a.marker }),
                Object(preact_min["h"])(
                    'span',
                    null,
                    data
                )
            );
        };

        _this3.budgetSourcesFormatter = function (cell) {
            var dataArray = cell.map(function (data) {
                return _this3.cellTextItem(data);
            });
            return Object(preact_min["h"])(
                'div',
                null,
                dataArray
            );
        };

        _this3.renderbudgetUtilizationYear = function (cell, row) {
            var dataArray = cell.map(function (data) {
                return Object(preact_min["h"])(
                    'div',
                    { 'class': component_style_default.a.budgetInnerWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.yearColumn },
                        Object(preact_min["h"])(
                            'span',
                            null,
                            data.year
                        )
                    )
                );
            });
            return Object(preact_min["h"])(
                'div',
                { 'class': component_style_default.a.budgetUtiWrapper },
                dataArray
            );
        };

        _this3.renderbudgetUtilizationBudget = function (cell, row) {
            var dataArray = cell.map(function (data) {
                return Object(preact_min["h"])(
                    'div',
                    { 'class': component_style_default.a.budgetInnerWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.yearColumn },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': component_style_default.a.priceColumn },
                            Object(numberFormatter["e" /* numberToDollarFormatter */])(data.total_budget)
                        )
                    )
                );
            });
            return Object(preact_min["h"])(
                'div',
                { 'class': component_style_default.a.budgetUtiWrapper },
                dataArray
            );
        };

        _this3.renderbudgetUtilizationExpense = function (cell) {
            var dataArray = cell.map(function (data) {
                return Object(preact_min["h"])(
                    'div',
                    { 'class': component_style_default.a.budgetInnerWrapper },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': component_style_default.a.yearColumn },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': component_style_default.a.priceColumn },
                            Object(numberFormatter["e" /* numberToDollarFormatter */])(data.total_expense)
                        )
                    )
                );
            });
            return Object(preact_min["h"])(
                'div',
                { 'class': component_style_default.a.budgetUtiWrapper },
                dataArray
            );
        };

        _this3.renderMarkers = function (data) {
            return Object(preact_min["h"])(
                'section',
                { 'class': component_style_default.a.markerSection },
                data.map(function (marker, index) {
                    var imageSrc = _.find(undpAboutUsData["a" /* aboutUsInfo */].data, function (element) {
                        return element.title === marker.title;
                    });
                    imageSrc = imageSrc ? imageSrc.image_2 : '';
                    return Object(preact_min["h"])(
                        'section',
                        { key: 'marker' + index, 'class': component_style_default.a.parentMarkers },
                        Object(preact_min["h"])(
                            'section',
                            { 'class': component_style_default.a.level },
                            Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.imageSection },
                                Object(preact_min["h"])('img', { 'class': component_style_default.a.headerImage, src: imageSrc })
                            ),
                            Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.textSection },
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': component_style_default.a.marker_header },
                                    marker.title
                                )
                            )
                        ),
                        Object(preact_min["h"])(expandableRow_ScrollSection, { marker: marker, index: index })
                    );
                })
            );
        };

        _this3.state = {
            data: undefined
        };
        return _this3;
    }

    ExpandableRow.prototype.render = function render(_ref, state) {
        var data = _ref.data;

        return Object(preact_min["h"])(
            'div',
            { 'class': component_style_default.a.parent },
            this.props.data && Object(preact_min["h"])(
                'section',
                { 'class': component_style_default.a.container },
                Object(preact_min["h"])(
                    'section',
                    { 'class': component_style_default.a.marker_container },
                    Object(preact_min["h"])(
                        'section',
                        { 'class': component_style_default.a.parent_container },
                        Object(preact_min["h"])(
                            'section',
                            { style: { width: '100%' }, 'class': component_style_default.a.table_container },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': component_style_default.a.card_container },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.child_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.item_title + ' ' + component_style_default.a.textCenter },
                                        'Year'
                                    ),
                                    Object(preact_min["h"])(
                                        'span',
                                        null,
                                        this.renderbudgetUtilizationYear(this.props.data.budget_utilization)
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.child_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.item_title + ' ' + component_style_default.a.textCenter },
                                        'Budget'
                                    ),
                                    Object(preact_min["h"])(
                                        'span',
                                        null,
                                        this.renderbudgetUtilizationBudget(this.props.data.budget_utilization)
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.child_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.item_title + ' ' + component_style_default.a.textCenter },
                                        'Expenditure'
                                    ),
                                    Object(preact_min["h"])(
                                        'span',
                                        null,
                                        this.renderbudgetUtilizationExpense(this.props.data.budget_utilization)
                                    )
                                )
                            )
                        ),
                        Object(preact_min["h"])(
                            'section',
                            { style: { display: 'none' }, 'class': component_style_default.a.table_container },
                            this.props.data.sector ? Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.subTables },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.budget_container },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.child_item },
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.item_title },
                                            'Programme Areas'
                                        ),
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.budgetBackground },
                                            Object(preact_min["h"])(
                                                'section',
                                                { 'class': component_style_default.a.cellElement },
                                                Object(preact_min["h"])(
                                                    'span',
                                                    null,
                                                    ' ',
                                                    this.props.data.sector,
                                                    ' '
                                                )
                                            )
                                        )
                                    )
                                )
                            ) : null,
                            this.props.signatureSol ? Object(preact_min["h"])(
                                'section',
                                { 'class': component_style_default.a.subTables },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.budget_container },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.child_item },
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.item_title },
                                            'Signature Solutions'
                                        ),
                                        Object(preact_min["h"])(
                                            'div',
                                            { 'class': component_style_default.a.budgetBackground },
                                            Object(preact_min["h"])(
                                                'section',
                                                { 'class': component_style_default.a.cellElement },
                                                Object(preact_min["h"])(
                                                    'span',
                                                    null,
                                                    ' ',
                                                    this.props.signatureSol,
                                                    ' '
                                                )
                                            )
                                        )
                                    )
                                )
                            ) : null,
                            this.props.data.policy_significance ? Object(preact_min["h"])(
                                'div',
                                { 'class': component_style_default.a.budget_container },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': component_style_default.a.child_item },
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.item_title },
                                        'Policy Marker'
                                    ),
                                    Object(preact_min["h"])(
                                        'div',
                                        { 'class': component_style_default.a.budgetBackground },
                                        Object(preact_min["h"])(
                                            'section',
                                            { 'class': component_style_default.a.cellElement },
                                            Object(preact_min["h"])(
                                                'span',
                                                { 'class': component_style_default.a.policyMarker },
                                                ' ',
                                                this.props.data.policy_marker,
                                                ' : '
                                            ),
                                            Object(preact_min["h"])(
                                                'span',
                                                null,
                                                ' ',
                                                this.props.data.policy_significance,
                                                ' '
                                            )
                                        )
                                    )
                                )
                            ) : null
                        )
                    ),
                    Object(preact_min["h"])(
                        'section',
                        { style: { display: 'none' }, 'class': component_style_default.a.parent_container },
                        this.props.marker.data[this.props.index] ? Object(preact_min["h"])(
                            'div',
                            { 'class': component_style_default.a.child },
                            this.props.marker.data[this.props.index].length > 0 ? Object(preact_min["h"])(
                                'div',
                                { 'class': component_style_default.a.item_title },
                                'Our Approach'
                            ) : null,
                            Object(preact_min["h"])(
                                'div',
                                null,
                                this.renderMarkers(this.props.marker.data[this.props.index])
                            )
                        ) : null
                    )
                )
            )
        );
    };

    return ExpandableRow;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    return {
        marker: state.markerDetails.output_list_markers
    };
};

/* harmony default export */ var expandableRow = (Object(preact_redux_esm["a" /* connect */])(mapStateToProps)(expandableRow_ExpandableRow));
// EXTERNAL MODULE: ./components/no-data-template/index.js
var no_data_template = __webpack_require__("wdDn");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/outputDetailActions.js
var outputDetailActions = __webpack_require__("mFZF");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/markerDetailsAction.js
var markerDetailsAction = __webpack_require__("x4+R");

// EXTERNAL MODULE: ./shared/actions/projectDetailActions/outputResultsActions.js
var outputResultsActions = __webpack_require__("voeE");

// CONCATENATED MODULE: ./static/assets/json/ourputResults.js
var outputResults = {
    "status": 200,
    "success": true,
    "data": [{
        "id": 92,
        "result_periods": [{
            "id": 233,
            "period_start": "2017-01-01",
            "period_end": "2017-12-31",
            "target": "3.  First Aid training and educational standards are unified and integrated into CMSA curriculum.\n5.1\n6.Early warning system established in 14 communities of Syunik region. The Geological Information System (GIS) software with cooperation of AUA and CMSA developed and tested  for the municipalities and MES for further replicated.\n7. DRM strategy adopted by the Government of Armenia.",
            "actual": "5.1\n6.Partially- Early warning system established in 7 communities of Syunik region.\n7.DRM strategy adopted by the Government of Armenia on April 7, 2017.",
            "result": 92
        }, {
            "id": 232,
            "period_start": "2016-01-01",
            "period_end": "2016-12-31",
            "target": "1. DRR Education policy for population mainstreamed into CMSA retraining curriculum.\n2. 0\n3. First Aid training and educational standards are unified and integrated into CMSA curriculum.\n4. 0\n5. 9\n6. Early warning system established in four cities (Center of Yerevan, Stepanavan, Dilijan and Kapan) and cellphone application developed and introduced. Smart city concept for Yerevan, Stepanavan developed and introduced.\n7. DRM capacity assessment conducted and DRM strategy developed based on the recommendations.\n8. The Minimum Initial Service training Package (MISP) developed and  integrated into CMSA professionals’ retraining  curriculum.\n9. City Resilience action plan for Dilijan and Kapan developed and for Stepanavan updated.\n10.3",
            "actual": "1.Available- Concept on DRR Education of Population mainstreamed into CMSA retraining curriculum.\n3.Partially-Inter-ministerial working group is formed and legislative framework is analyzed.\n5.9\n6.Partially-Early warning system established in four cities (Center of Yerevan, Stepanavan, Dilijan and Kapan) and cellphone application developed and introduced. Smart city concept for Yerevan and Stepanavan developed and introduced.\n7.Available-Capacity assessment conducted in cooperation with the World Bank and the Ministry of the Emergency Situations. The  report is developed and endorsed by the Government.\n8.Available- MISP training package developed in cooperation with UNFPA and integrated into CMSA  curriculum.\n9.Available-City Resilience Action Plan for Stepanavan, Dilijan and Kapan cities are developed.\n10.3",
            "result": 92
        }, {
            "id": 231,
            "period_start": "2015-01-01",
            "period_end": "2015-12-31",
            "target": "1. Concept on DRR Education of Population approved\n2. 8\n3. Renovation of the premises of CMSA completed, bio-safety class established and provided with transportation means \n4. 3    \n5. 0\n6. Draft of Smart city concept  for Yerevan city and cellphone application of early warning system developed\n7. Disaster Risk Reduction Strategy  update based on Sendai Framework for action (SFA) initiated\n8. Minimum Initial Service training package integrated into CMSA retraining curriculum\n9. Not applicable",
            "actual": "1. Available-concept on DRR Education of Population approved by the Government\n2. 8\n3. Available-two training packages integrated into curriculum, renovation of premises completed, transportation means provided and mobile bio-safety class  established\n4. 3\n5. 0\n6. Partially-the draft of the Smart city concept for Yerevan and mobile application of early warning system developed and presented to the Government \n7. Partially-thematic working group within DRR National Platform formed and Working  plan for  updating DRR National Strategy based on SFA  developed\n8. Partially - the development of the training package started\n9. Not applicable",
            "result": 92
        }],
        "sector": "Climate Change  Disaster Resilience",
        "result_type": 1,
        "aggregation_status": 1,
        "indicator_title": "Output Indicator",
        "indicator_description": "1. Availability of educational policy on Disaster Risk Reduction (DRR) for population. \n2. Number of Crisis Management Centers decentralized and replicated in the regions of Armenia \n3. Level of technical and educational capacities of the CMSA.\n4. Number of cities that joined City Resilience campaign.\n5. Number of communities where Local Level Risk Management has been conducted and Community Risk Certificate piloted.\n6. Availability of Information Technologies solution for the Disaster Risk Management (DRM)\n7. Availability of Disaster Risk Reduction strategy and Action Plan for 2016-2020 through Disaster Risk Reduction National Platform (DRR National Platform)\n8. Availability of  Minimum Initial Service training package integrated into  disaster management framework\n9. Availability of risk informed urban development plans in Dilijan and Stepanavan\n10.Number of the communities where multi-risk GIS based profile developed.",
        "indicator_measure": 1,
        "indicator_ascending": 0,
        "baseline_year": "2010",
        "baseline_comment": "1. None (2013)\n2. 0 (2014)\n3. Not available- technical and educational capacities at the Crisis Management State Academy CMSA (2013)\n4. 3 (2013)\n5. 12 (2013)\n6. Not available (2014)\n7. Lack of required capacities (2013)\n8. Not available (2013)\n9. Lack of risk informed urban development plans in Dilijan and Stepanavan (2014)\n10.0 (2015)",
        "output": "00076016",
        "project": "00011263"
    }]
};
// CONCATENATED MODULE: ./static/assets/json/outputDetailData.js
var outputDetailData = {
    "success": true,
    "data": {
        "output_id": "00076016",
        "project": "00011263",
        "sector": "Climate Change  Disaster Resilience",
        "budget_sources": ["European Comm. Humanit. Aid Of", "ARM-Syunic Dev. & Invest. Fdn.", "Armenia Government", "National Platform on DRR", "UNITED NATIONS DEVELOPMENT PRO"],
        "policy_marker": "Gender Equality",
        "budget_utilization": [{
            "total_budget": 420000,
            "total_expense": 418762.2,
            "year": 2011
        }, {
            "total_budget": 119458,
            "total_expense": 119363,
            "year": 2013
        }, {
            "total_budget": 37200,
            "total_expense": 22384,
            "year": 2014
        }, {
            "total_budget": 151841,
            "total_expense": 137734,
            "year": 2016
        }, {
            "total_budget": 82152,
            "total_expense": 63570,
            "year": 2017
        }],
        "aid_type": "Project-type interventions"
    },
    "status": 200
};
// EXTERNAL MODULE: ../node_modules/react-ga/dist/react-ga.js
var react_ga = __webpack_require__("Z70r");
var react_ga_default = /*#__PURE__*/__webpack_require__.n(react_ga);

// EXTERNAL MODULE: ./components/nestedCards/style.scss
var nestedCards_style = __webpack_require__("q4r3");
var nestedCards_style_default = /*#__PURE__*/__webpack_require__.n(nestedCards_style);

// EXTERNAL MODULE: ./static/assets/icons/View_Results_Icon.png
var View_Results_Icon = __webpack_require__("XI/t");
var View_Results_Icon_default = /*#__PURE__*/__webpack_require__.n(View_Results_Icon);

// CONCATENATED MODULE: ./components/nestedCards/index.js


function nestedCards__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function nestedCards__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function nestedCards__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var nestedCards__ref3 = Object(preact_min["h"])(
    'span',
    null,
    Object(preact_min["h"])(
        'b',
        null,
        'SDGs: '
    )
);

var nestedCards__ref4 = Object(preact_min["h"])(
    'span',
    null,
    Object(preact_min["h"])(
        'b',
        null,
        'Markers: '
    )
);

var nestedCards__ref5 = Object(preact_min["h"])(
    'tr',
    null,
    Object(preact_min["h"])(
        'th',
        null,
        'Year'
    ),
    Object(preact_min["h"])(
        'th',
        null,
        'Budget'
    ),
    Object(preact_min["h"])(
        'th',
        null,
        'Expenditure'
    )
);

var nestedCards_Card = function (_Component) {
    nestedCards__inherits(Card, _Component);

    function Card(props) {
        nestedCards__classCallCheck(this, Card);

        var _this = nestedCards__possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleLessDetailsClick = function () {
            _this.setState({
                genderState: !_this.state.genderState
            }, function () {
                _this.props.fetchProjectOutputDetail(_this.props.data.output_id, _this.props.index);
                _this.props.fetchmarkerDetail(_this.props.data.output_id, _this.props.index);
            });
        };

        _this.handleViewResultsClick = function () {
            _this.props.renderViewDetailPhone(_this.props.data.has_result, _this.props.data, null, _this.props.index);
        };

        _this.generateBudgetSourcesList = function (data) {
            if (data.length) {
                return data.map(function (item) {
                    return Object(preact_min["h"])(
                        'li',
                        null,
                        item
                    );
                });
            }
        };

        _this.renderSubMarkers = function (data) {
            var sectionData = data.map(function (subdata, index) {
                if (typeof subdata.sublevel !== 'undefined') {
                    return Object(preact_min["h"])(
                        'ul',
                        { key: index },
                        Object(preact_min["h"])(
                            'li',
                            { 'class': nestedCards_style_default.a.subheader },
                            subdata.title
                        ),
                        _this.renderSubMarkers(subdata.sublevel)
                    );
                } else {
                    return Object(preact_min["h"])(
                        'li',
                        { 'class': nestedCards_style_default.a.sub_section, key: subdata.title + index },
                        Object(preact_min["h"])('img', { src: '/static/assets/icons/bullets.svg', alt: '\\2022', 'class': nestedCards_style_default.a.bullet }),
                        subdata.title
                    );
                }
            });
            return sectionData;
        };

        _this.renderMarkers = function (data) {
            var sectionData = data.map(function (subdata, index) {
                var imageSrc = _.find(undpAboutUsData["a" /* aboutUsInfo */].data, function (element) {
                    return subdata.title === element.title;
                });
                imageSrc = imageSrc ? imageSrc.image_2 : '';
                return Object(preact_min["h"])(
                    'ul',
                    { key: index },
                    Object(preact_min["h"])('img', { src: imageSrc, style: { width: 20, verticalAlign: 'top' } }),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': nestedCards_style_default.a.header },
                        subdata.title
                    ),
                    _this.renderSubMarkers(subdata.sublevel)
                );
            });
            return Object(preact_min["h"])(
                'section',
                null,
                sectionData
            );
        };

        _this.generateTable = function (data) {
            return data.map(function (element) {
                return Object(preact_min["h"])(
                    'tr',
                    null,
                    Object(preact_min["h"])(
                        'td',
                        null,
                        element.year
                    ),
                    Object(preact_min["h"])(
                        'td',
                        null,
                        Object(numberFormatter["e" /* numberToDollarFormatter */])(element.total_budget)
                    ),
                    Object(preact_min["h"])(
                        'td',
                        null,
                        Object(numberFormatter["e" /* numberToDollarFormatter */])(element.total_expense)
                    )
                );
            });
        };

        _this.state = {
            genderState: false
        };
        return _this;
    }

    Card.prototype.render = function render(_ref, _ref2) {
        var _this2 = this;

        var data = _ref.data,
            fields = _ref.fields;
        var genderState = _ref2.genderState;

        return Object(preact_min["h"])(
            'div',
            { 'class': nestedCards_style_default.a.container },
            Object(preact_min["h"])(
                'div',
                { 'class': nestedCards_style_default.a.innerContainer },
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': '' + nestedCards_style_default.a.title },
                        data.title
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': '' + nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': '' + nestedCards_style_default.a.projectId },
                        '# ' + data.output_id
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'section',
                        { style: { marginTop: 20, marginBottom: 15 } },
                        nestedCards__ref3,
                        Object(preact_min["h"])(
                            'span',
                            { 'class': nestedCards_style_default.a.sdgData },
                            data.sdg ? Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.value },
                                data.sdg.map(function (element) {
                                    return Object(preact_min["h"])('img', { style: { width: 35, marginRight: 5 }, src: '/static/assets/icons/' + element + '.svg', alt: element });
                                })
                            ) : null
                        )
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'div',
                        null,
                        data.description
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    nestedCards__ref4,
                    Object(preact_min["h"])(
                        'span',
                        { 'class': nestedCards_style_default.a.value },
                        data.markers.map(function (element) {
                            var currentMarker = _.find(undpAboutUsData["a" /* aboutUsInfo */].data, function (marker) {
                                return marker.id === element;
                            });
                            return Object(preact_min["h"])('img', { style: { width: 35, marginRight: 5 }, src: currentMarker.img });
                        })
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.cardDetails },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': nestedCards_style_default.a.resultsWrapper },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': nestedCards_style_default.a.results },
                            this.props.data.has_result ? Object(preact_min["h"])('div', { 'class': nestedCards_style_default.a.view_results,
                                onClick: function onClick() {
                                    _this2.handleViewResultsClick();
                                }
                            }) : null
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { onClick: function onClick() {
                                    _this2.handleLessDetailsClick();
                                }, 'class': nestedCards_style_default.a.lessDetails },
                            Object(preact_min["h"])('div', { 'class': !genderState ? '' + nestedCards_style_default.a.moreDetailImage : ' ' + nestedCards_style_default.a.lessDetailImage + ' ' }),
                            Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.lessDetailsText },
                                genderState ? 'LESS DETAILS' : 'MORE DETAILS'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': nestedCards_style_default.a.genderEquality, style: genderState ? { display: 'block' } : { display: 'none' } },
                Object(preact_min["h"])(
                    'div',
                    { 'class': nestedCards_style_default.a.budgetSources },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                        'Donors'
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        null,
                        this.generateBudgetSourcesList(data.output_detail ? data.output_detail.budget_sources ? data.output_detail.budget_sources : [] : [])
                    ),
                    Object(preact_min["h"])(
                        'table',
                        { 'class': nestedCards_style_default.a.budgetTable },
                        nestedCards__ref5,
                        this.generateTable(data.output_detail ? data.output_detail.budget_utilization ? data.output_detail.budget_utilization : [] : [])
                    ),
                    data.sector ? Object(preact_min["h"])(
                        'section',
                        null,
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                            ' Programme Areas'
                        ),
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.policyMarkerSection },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.policyMarker },
                                ' ',
                                data.sector
                            )
                        )
                    ) : null,
                    data.signature_solution ? Object(preact_min["h"])(
                        'section',
                        null,
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                            ' Signature Solutions'
                        ),
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.policyMarkerSection },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.policyMarker },
                                ' ',
                                data.signature_solution
                            )
                        )
                    ) : null,
                    data.policy_significance ? Object(preact_min["h"])(
                        'section',
                        null,
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                            ' Policy Marker'
                        ),
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.policyMarkerSection },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': nestedCards_style_default.a.policyMarker },
                                ' ',
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': nestedCards_style_default.a.policyMarkerHeading },
                                    data.output_detail ? data.output_detail.policy_marker : null
                                ),
                                ' : ',
                                data.output_detail ? data.output_detail.policy_significance : null
                            )
                        )
                    ) : null,
                    this.props.marker.data ? Object(preact_min["h"])(
                        'section',
                        null,
                        Object(preact_min["h"])(
                            'section',
                            { 'class': nestedCards_style_default.a.budgetSourcesHeading },
                            'Our Approach'
                        ),
                        Object(preact_min["h"])(
                            'section',
                            null,
                            this.renderMarkers(this.props.marker.data)
                        )
                    ) : null
                )
            )
        );
    };

    return Card;
}(preact_min["Component"]);

var nestedCards_mapStateToProps = function mapStateToProps(state) {
    return {
        marker: state.markerDetails
    };
};

/* harmony default export */ var nestedCards = (Object(preact_redux_esm["a" /* connect */])(nestedCards_mapStateToProps)(nestedCards_Card));
// EXTERNAL MODULE: ./utils/commonMethods.js
var commonMethods = __webpack_require__("Cdrj");

// CONCATENATED MODULE: ./components/projectDetailTable/index.js


function projectDetailTable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function projectDetailTable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function projectDetailTable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var projectDetailTable__ref = Object(preact_min["h"])(preLoader["a" /* default */], null);

var projectDetailTable__ref3 = Object(preact_min["h"])(preLoader["a" /* default */], null);

var projectDetailTable__ref4 = Object(preact_min["h"])(no_data_template["a" /* default */], null);

var projectDetailTable__ref5 = Object(preact_min["h"])('link', { rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css' });

var projectDetailTable_ProjectOutputTable = function (_Component) {
    projectDetailTable__inherits(ProjectOutputTable, _Component);

    function ProjectOutputTable(props) {
        projectDetailTable__classCallCheck(this, ProjectOutputTable);

        var _this = projectDetailTable__possibleConstructorReturn(this, _Component.call(this, props));

        _this.imageFormatter = function (cell, row) {
            var imgSrc = [];
            if (cell) {
                if (typeof cell[0] === 'number') {
                    var currentMarker = void 0;
                    cell.forEach(function (element) {
                        currentMarker = _.find(undpAboutUsData["a" /* aboutUsInfo */].data, function (marker) {
                            return marker.id === element;
                        });
                        imgSrc.push(currentMarker ? { src: Object(commonMethods["d" /* getAPIBaseUrRl */])() + currentMarker.image_2, alt: currentMarker.title, type: 1 } : { src: '', alt: '', type: 1 });
                    });
                } else if (typeof cell[0] === 'string') {
                    cell.forEach(function (element) {
                        imgSrc.push({ src: Object(commonMethods["d" /* getAPIBaseUrRl */])() + ('/static/assets/icons/' + element + '.svg'), alt: element, type: 2 });
                    });
                }
            }
            return Object(preact_min["h"])(
                'section',
                { 'class': style_default.a.markerImageSection },
                imgSrc.map(function (element) {
                    return Object(preact_min["h"])('img', { style: { width: element.type === 1 ? 25 : 40, marginLeft: 10, marginBottom: 20 }, src: element.src, alt: element.alt });
                })
            );
        };

        _this.onCloseModal = function () {
            _this.setState({ modalState: false, resultIndex: undefined });
        };

        _this.onRowClick = function (row, cell, rowIndex) {
            _this.props.fetchProjectOutputDetail(row.output_id, rowIndex);
            _this.props.fetchmarkerDetail(row.output_id, rowIndex);
        };

        _this.renderViewDetail = function (cell, row, enumObject, rowIndex) {
            return Object(preact_min["h"])(
                'span',
                { className: style_default.a.viewDetail, onClick: function onClick() {
                        react_ga_default.a.ga('send', 'event', 'Output Results', 'Output ID', row.output_id);
                        if (row.has_result) {
                            _this.props.fetchProjectOutputResults(row.output_id, rowIndex);
                            if (!_this.state.modalState) {
                                _this.setState({ modalState: true, resultIndex: rowIndex });
                                // this.setState({ modalState: true, resultIndex:rowIndex, modalData: row.output_results });
                            }
                        }
                    } },
                cell && Object(preact_min["h"])('span', { 'class': style_default.a.view_results })
            );
        };

        _this.renderViewDetailPhone = function (cell, row, enumObject, rowIndex) {
            react_ga_default.a.ga('send', 'event', 'Output Results', 'Output ID', row.output_id);
            if (row.has_result) {
                _this.props.fetchProjectOutputResults(row.output_id, rowIndex);
                if (!_this.state.modalState) {
                    _this.setState({ modalState: true, resultIndex: rowIndex });
                    // this.setState({ modalState: true, resultIndex:rowIndex, modalData: row.output_results });
                }
            }
        };

        _this.renderThemeColumn = function (cell, row) {
            return Object(preact_min["h"])(
                'span',
                null,
                cell
            );
        };

        _this.isExpandableRow = function (row) {
            return true;
        };

        _this.expandComponent = function (row) {
            if (row.output_detail) {
                return Object(preact_min["h"])(expandableRow, { data: row.output_detail, index: row.id, signatureSol: row.signature_solution });
            } else return Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.preloaderWrapper },
                projectDetailTable__ref
            );
        };

        _this.expandComponentStyle = function (row, rowIndex, isExpanding) {
            if (!isExpanding) {
                //collapsed
                return null;
            } else {
                return style_default.a.selectedRow;
            }
        };

        _this.generateCardList = function (dataArray) {
            if (dataArray.length) {
                return dataArray.map(function (item, index) {
                    return Object(preact_min["h"])(nestedCards, {
                        data: item,
                        index: index,
                        fetchProjectOutputResults: _this.props.fetchProjectOutputResults,
                        fetchProjectOutputDetail: _this.props.fetchProjectOutputDetail,
                        fetchmarkerDetail: _this.props.fetchmarkerDetail,
                        renderViewDetailPhone: _this.renderViewDetailPhone
                    });
                });
            } else {
                return [];
            }
        };

        _this.state = {
            modalState: false,
            resultIndex: undefined,
            modalData: {},
            data: [{
                heading: 'Indicators',
                sub: [{
                    id: 1,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }, {
                    id: 2,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }, {
                    id: 3,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }]
            }, {
                heading: 'Baseline',
                sub: [{
                    id: 1,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }, {
                    id: 2,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }, {
                    id: 3,
                    text: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.'
                }]
            }],
            years: [{
                id: 1,
                year: 2015,
                active: true
            }, {
                id: 2,
                year: 2016,
                active: false
            }],
            popupFooterContent: [{
                id: 1,
                heading: 'Target',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.'
            }, {
                id: 2,
                heading: 'Result',
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.'
            }]
        };
        return _this;
    }

    ProjectOutputTable.prototype.getSDGColumnWidth = function getSDGColumnWidth() {
        if (!this.props.projectDetail.output_list.loading) {
            var maxLenItem = _.max(this.props.projectDetail.output_list.data, function (o) {
                return o.sdg.length;
            });
            if (maxLenItem && maxLenItem.sdg && maxLenItem.sdg.length >= 3) return '15%';else if (maxLenItem && maxLenItem.sdg && maxLenItem.sdg.length === 2) return '10%';else return '7%';
        }
    };

    ProjectOutputTable.prototype.render = function render(_ref2, state) {
        var _this2 = this;

        var data = _ref2.data;
        var outputs = this.props.projectDetail.output_list.data;
        var loading = this.props.projectDetail.output_list.loading;

        var options = {
            expandBy: 'column',
            expandBodyClass: this.expandComponentStyle,
            onRowClick: this.onRowClick,
            noDataText: loading ? Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.preloaderWrapper },
                projectDetailTable__ref3
            ) : projectDetailTable__ref4

        };
        var tableData = loading ? [] : this.props.projectDetail.output_list.data;
        tableData && tableData.length != 0 ? tableData = tableData.map(function (element, index) {
            element.id = index;return element;
        }) : [];

        var columns = [{
            dataField: 'output_id',
            text: 'Product ID'
        }, {
            dataField: 'title',
            text: 'Product Name'
        }, {
            dataField: 'start_date',
            text: 'Product Price'
        }, {
            dataField: 'end_date',
            text: 'Product Price'
        }, {
            dataField: 'status',
            text: 'Product Price'
        }];
        return Object(preact_min["h"])(
            'div',
            { 'class': style_default.a.projectList },
            projectDetailTable__ref5,
            Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.tableOuterWrapper },
                Object(preact_min["h"])(
                    lib["BootstrapTable"],
                    {
                        options: options,
                        expandableRow: function expandableRow(row) {
                            return _this2.isExpandableRow(row);
                        },
                        expandComponent: function expandComponent(row) {
                            return _this2.expandComponent(row);
                        },
                        data: loading ? [] : tableData,
                        striped: true,
                        bordered: false,
                        version: '4',
                        headerContainerClass: style_default.a.headerContainerClass,
                        headerStyle: { borderTop: '#337ab7 3px solid', borderBottom: 0, background: '#fffff' },
                        bodyStyle: { height: 'auto', background: '#cccc', marginBottom: 0, paddingRight: 0 },
                        tableBodyClass: style_default.a.tableBodyClass,
                        bodyContainerClass: style_default.a.bodyContainerClass
                    },
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' },
                            dataField: 'output_id', isKey: true },
                        'ID'
                    ),
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' }, dataField: 'title' },
                        'Contract Titles'
                    ),
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' }, dataField: 'budget_sources' },
                        'Donor'
                    ),
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' }, dataField: 'start_date' },
                        'Start Date'
                    ),
                    Object(preact_min["h"])(
                        lib["TableHeaderColumn"],
                        { width: '200',
                            tdStyle: { whiteSpace: 'normal', wordWrap: 'break-word' }, dataField: 'end_date' },
                        'End Date'
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.cardListOuterWrapper },
                this.generateCardList(this.props.projectDetail.output_list.data ? this.props.projectDetail.output_list.data : [])
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': style_default.a.modalWrapper },
                this.state.modalState && state.resultIndex >= 0 &&
                // outputs[state.resultIndex].output_results
                // && Object.keys(outputs[state.resultIndex].output_results).length > 0) &&
                Object(preact_min["h"])(outputResults_OutputResults, { onCloseModal: this.onCloseModal, data: outputs[state.resultIndex].output_results })
            )
        );
    };

    return ProjectOutputTable;
}(preact_min["Component"]);

var projectDetailTable_mapStateToProps = function mapStateToProps(state) {
    return {
        projectDetail: state.projectDetail
    };
};

var projectDetailTable_mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchProjectOutputDetail: function fetchProjectOutputDetail(output_id, index) {
            return dispatch(Object(outputDetailActions["b" /* fetchProjectOutputDetail */])(output_id, index));
        },
        fetchmarkerDetail: function fetchmarkerDetail(output_id, index) {
            return dispatch(Object(markerDetailsAction["b" /* fetchmarkerDetail */])(output_id, index));
        },
        fetchProjectOutputResults: function fetchProjectOutputResults(output_id, index) {
            return dispatch(Object(outputResultsActions["b" /* fetchProjectOutputResults */])(output_id, index));
        }
    };
};

/* harmony default export */ var projectDetailTable = __webpack_exports__["a"] = (Object(preact_redux_esm["a" /* connect */])(projectDetailTable_mapStateToProps, projectDetailTable_mapDispatchToProps)(projectDetailTable_ProjectOutputTable));

/***/ }),

/***/ "VSTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__("tokj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__("sqGb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_redux__ = __webpack_require__("E/bI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__ = __webpack_require__("Au7/");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AreaChartView = function (_Component) {
    _inherits(AreaChartView, _Component);

    function AreaChartView() {
        _classCallCheck(this, AreaChartView);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.componentWillReceiveProps = function (nextProps) {
            var budget_utilization = nextProps.projectDetail.budget_utilization,
                expense_data = budget_utilization.expense_data,
                budget_data = budget_utilization.budget_data;


            if (nextProps.projectDetail.budget_utilization != _this.props.projectDetail.budget_utilization) {
                _this.setState({
                    budget_utilization: nextProps.projectDetail.budget_utilization
                }, function () {
                    if (expense_data && budget_data) {
                        _this.drawAreaChart();
                    }
                });
            }
        };

        _this.drawAreaChart = function () {
            var widthOfDevice = window.outerWidth;
            var formatxAxis = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.format('.0f');
            var formatyAxis = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.format('');
            var margin = { top: 20, right: 20, bottom: 30, left: 70 },
                height = 250 - margin.top - margin.bottom,
                width = 500 - margin.left - margin.right;
            var x = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.scale.linear().range([0, width]);

            var tickLength = _this.props.projectDetail.budget_utilization.expense_data.length !== 0 ? _this.props.projectDetail.budget_utilization.expense_data.length - 1 : 1;

            var addedHeigth = height + margin.top + margin.bottom;

            var y = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.scale.linear().range([height, 0]);
            var xAxis = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.axis().scale(x).orient("bottom").ticks(tickLength).tickFormat(formatxAxis);

            var yAxis = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.axis().scale(y).orient("left").ticks(5).tickFormat(function (d) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(d, 0);
            });

            var areaBudget = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.area().x(function (d) {
                return x(d.year);
            }).y0(height).y1(function (d) {
                return y(d.budget);
            });
            var areaExpense = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.area().x(function (d) {
                return x(d.year);
            }).y0(height).y1(function (d) {
                return y(d.expense);
            });

            var lineFuncExpense = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.line().x(function (d) {
                return x(d.year);
            }).y(function (d) {
                return y(d.expense);
            });
            var lineFuncBudget = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.svg.line().x(function (d) {
                return x(d.year);
            }).y(function (d) {
                return y(d.budget);
            });

            if (!__WEBPACK_IMPORTED_MODULE_1_d3___default.a.select('#area_chart').empty()) {
                __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select('#area_chart' + ' svg').remove();
            }

            var addedWidth = width + margin.left + margin.right;

            var svg = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select("#area_chart").append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", "0 0 " + addedWidth + " " + addedHeigth).classed('' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.svgContent, true).classed('' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.svgIe, true).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

            var div = __WEBPACK_IMPORTED_MODULE_1_d3___default.a.select("#display_label").attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.tooltip).style("opacity", 0);

            x.domain(__WEBPACK_IMPORTED_MODULE_1_d3___default.a.extent(_this.props.projectDetail.budget_utilization.budget_data, function (d) {
                return d.year;
            }));
            y.domain([0, __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(_this.props.projectDetail.budget_utilization.expense_data, function (d) {
                return d.expense;
            }) > __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(_this.props.projectDetail.budget_utilization.budget_data, function (d) {
                return d.budget;
            }) ? __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(_this.props.projectDetail.budget_utilization.expense_data, function (d) {
                return d.expense;
            }) : __WEBPACK_IMPORTED_MODULE_1_d3___default.a.max(_this.props.projectDetail.budget_utilization.budget_data, function (d) {
                return d.budget;
            })]);

            svg.append("path").datum(_this.props.projectDetail.budget_utilization.budget_data).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.chart_area1).attr("d", areaBudget);

            svg.append("path").datum(_this.props.projectDetail.budget_utilization.budget_data).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.line_chart1) // with a darker color
            .attr("d", lineFuncBudget);

            svg.append("path").datum(_this.props.projectDetail.budget_utilization.expense_data).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.chart_area2).attr("d", areaExpense);

            svg.append("path").datum(_this.props.projectDetail.budget_utilization.expense_data).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.line_chart2) // with a darker color
            .attr("d", lineFuncExpense);

            svg.selectAll("dot").data(_this.props.projectDetail.budget_utilization.budget_data).enter().append("circle").attr("r", 3.5).attr("cx", function (d) {
                return x(d.year);
            }).attr("cy", function (d) {
                return y(d.budget);
            }).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.budgetDot).on("mouseover", function (d) {
                div.transition().duration(200).style("opacity", 1);

                div.html('<span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.yearDisplay + '>' + d.year + '</span><div class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.contentWrapper + '><div class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.markerWrapper + '><span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.budgetMarker + '></span></div><div><span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.expenseWrapper + '>Budget : ' + Object(__WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(d.budget, 2) + '</span></div></div>').style("left", __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.pageX - 150 + "px").style("top", __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.pageY + "px");
            }).on("mouseout", function (d) {
                div.transition().duration(500).style("opacity", 0);
            });
            svg.selectAll("dot").data(_this.props.projectDetail.budget_utilization.expense_data).enter().append("circle").attr("r", 3.5).attr("cx", function (d) {
                return x(d.year);
            }).attr("cy", function (d) {
                return y(d.expense);
            }).attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.budgetDot).on("mouseover", function (d) {
                div.transition().duration(200).style("opacity", 1);

                div.html('<span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.yearDisplay + '>' + d.year + '</span><div class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.contentWrapper + '><div class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.markerWrapper + '><span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.expenseMarker + '></span></div><div><span class=' + __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.expenseWrapper + '>Expenditure : ' + Object(__WEBPACK_IMPORTED_MODULE_4__utils_numberFormatter__["d" /* numberToCurrencyFormatter */])(d.expense, 2) + '</span></div></div>').style("left", __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.pageX - 150 + "px").style("top", __WEBPACK_IMPORTED_MODULE_1_d3___default.a.event.pageY + "px");
            }).on("mouseout", function (d) {
                div.transition().duration(500).style("opacity", 0);
            });

            svg.append("g").attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.xaxis).attr("transform", "translate(0," + height + ")").call(xAxis);
            //.attr("stroke", "#191818");


            svg.append("g").attr("class", __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.yaxis).call(yAxis)
            //.attr("stroke", "#191818")
            .append("text").attr("transform", "rotate(-90)").attr("dy", "1em").style("text-anchor", "end");
        };

        _this.state = {
            budget_utilization: {}
        };
        return _this;
    }

    AreaChartView.prototype.componentDidMount = function componentDidMount() {
        var budget_data = this.props.projectDetail.budget_utilization.budget_data,
            expense_data = this.props.projectDetail.budget_utilization.expense_data;
        if (Object.keys(this.props.projectDetail.budget_utilization).length && budget_data && expense_data) this.drawAreaChart();
    };

    AreaChartView.prototype.render = function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { id: 'area_chart', 'class': __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.area_chart },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { id: 'display_label', className: __WEBPACK_IMPORTED_MODULE_2__style_scss___default.a.tooltip })
        );
    };

    return AreaChartView;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
    return {
        projectDetail: state.projectDetail
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {};
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_preact_redux__["a" /* connect */])(mapStateToProps, mapDispatchToProps)(AreaChartView));

/***/ }),

/***/ "Vhkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_redux__ = __webpack_require__("E/bI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_map__ = __webpack_require__("wvix");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_areaChart__ = __webpack_require__("VSTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_project_timeline__ = __webpack_require__("OXGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__downloadModal__ = __webpack_require__("ItF+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_no_data_template__ = __webpack_require__("wdDn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_shared_actions_projectDetailActions__ = __webpack_require__("csCp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__donutBarChart__ = __webpack_require__("pwGw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__projectDonutBarChart__ = __webpack_require__("Gnd3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_preact_helmet__ = __webpack_require__("FJnM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_preact_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_preact_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_scss__ = __webpack_require__("JNi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3__ = __webpack_require__("tokj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_d3__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/************************* Preact Files ************************/



/************************* Custom Component Files ************************/








/************************* Third Party  Files ************************/


/************************* Style Files ************************/



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'span',
	null,
	'Budget Utilisation'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'span',
	null,
	'Budget'
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'span',
	null,
	'Expenditure'
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__components_areaChart__["a" /* default */], null);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	null,
	'SATELLITE DATA TEXT'
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	null,
	'FINAL CONDITION'
);

var ProjectDescription = function (_Component) {
	_inherits(ProjectDescription, _Component);

	function ProjectDescription(props) {
		_classCallCheck(this, ProjectDescription);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentDidMount = function () {
			var year = _this.props.mapCurrentYear;
		};

		_this.openModal = function (type) {
			_this.setState({ expand: true, maptype: type });
		};

		_this.closeModal = function () {
			_this.setState({ expand: false });
		};

		_this.changeIframeSrc = function (type) {
			var source = '';
			switch (type) {
				case 'prev':
					if (_this.currentLocationIndex > 0) {
						_this.currentLocationIndex--;
						if (_this.props.satelliteData[_this.currentLocationIndex - 1]) {
							_this.setState({ prevLocation: _this.props.satelliteData[_this.currentLocationIndex - 1] });
							_this.showPrev = true;
						} else {
							_this.setState({ prevLocation: { location: '', source: '' } });
							_this.showPrev = false;
						}
						_this.setState({ currentLocation: _this.props.satelliteData[_this.currentLocationIndex] });
						_this.setState({ nextLocation: _this.props.satelliteData[_this.currentLocationIndex + 1] });
						source = _this.state.currentLocation.source;
					} else {
						_this.setState({ prevLocation: { location: '', source: '' } });
						_this.showPrev = false;
					}
					if (_this.state.nextLocation.source) _this.showNext = true;else _this.showNext = false;

					break;
				case 'next':
					if (_this.currentLocationIndex < _this.props.satelliteData.length - 1) {
						_this.setState({ prevLocation: _this.props.satelliteData[_this.currentLocationIndex] });
						_this.currentLocationIndex++;
						_this.setState({ currentLocation: _this.props.satelliteData[_this.currentLocationIndex] });
						_this.setState({ nextLocation: _this.props.satelliteData[_this.currentLocationIndex + 1] });
						source = _this.state.currentLocation.source;
						_this.showNext = true;
						if (_this.currentLocationIndex === _this.props.satelliteData.length - 1) {
							_this.setState({ nextLocation: { location: '', source: '' } });
							_this.showNext = false;
						}
					} else {
						_this.setState({ nextLocation: { location: '', source: '' } });
						_this.showNext = false;
					}
					if (_this.state.prevLocation.source) _this.showPrev = true;else _this.showPrev = false;
					break;
			}
		};

		_this.countryRegionList = function (dataArray) {
			if (dataArray && dataArray.length) {
				return dataArray.map(function (item, index) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'span',
						null,
						item.country_name,
						dataArray.length - 1 == index ? '' : ',',
						' '
					);
				});
			} else {
				return [];
			}
		};

		_this.state = {
			isInfo: false,
			expand: false,
			mapType: 'map',
			prevLocation: { location: '', source: '' },
			currentLocation: { location: '', source: '' },
			nextLocation: { location: '', source: '' },
			showText: false,
			showTextDesc2: false,
			iucnMember: false,
			iucnNonMember: false
		};
		_this.currentLocationIndex = 0;
		_this.showNext = false;
		_this.showPrev = false;

		return _this;
	}

	ProjectDescription.prototype.changeSatelliteSrc = function changeSatelliteSrc(currentLocationIndex) {
		this.currentLocationIndex = currentLocationIndex;
		if (this.props.satelliteData && this.props.satelliteData.length) {
			if (this.currentLocationIndex === 0) {
				this.setState({ prevLocation: { location: '', source: '' } });
				this.showPrev = false;
			} else {
				this.setState({ prevLocation: this.props.satelliteData[this.currentLocationIndex - 1] });
				this.showPrev = true;
			}
			this.setState({ currentLocation: this.props.satelliteData[this.currentLocationIndex] });
			if (this.props.satelliteData.length > 1 && this.currentLocationIndex !== this.props.satelliteData.length - 1) {
				this.setState({ nextLocation: this.props.satelliteData[this.currentLocationIndex + 1] });
				this.showNext = true;
			} else {
				this.showNext = false;
			}
		}
	};

	ProjectDescription.prototype.setMapType = function setMapType(type) {
		if (type === 'satellite') {
			this.setState({ mapType: 'satellite' });
			if (this.props.satelliteData && this.props.satelliteData.length) {
				this.setState({ prevLocation: { location: '', source: '' } });
				this.setState({ currentLocation: this.props.satelliteData[this.currentLocationIndex] });
				if (this.props.satelliteData.length > 1) {
					this.setState({ nextLocation: this.props.satelliteData[this.currentLocationIndex + 1] });
					this.showNext = true;
				} else {
					this.showNext = false;
				}
			}
		} else {
			this.setState({ mapType: 'map' });
		}
	};

	ProjectDescription.prototype.render = function render(props) {
		var _this2 = this,
		    _ref2;

		var isProjectDetailNonEmpty = Object.keys(this.props.projectDetail.project).length > 0;
		var data = this.props.mapCountryData.outputData.data ? this.props.mapCountryData.outputData.data[0] : [];
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.container, style: { paddingTop: "15px" } },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'p',
				{ style: { color: '#191818', fontWeight: "600", marginLeft: "1.4%" } },
				' Project ID: ',
				this.props.projectDetail && this.props.projectDetail.project.project_id,
				'  \xA0  Project Status: ',
				this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.status,
				' '
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ style: { width: '100%', display: 'flex' } },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ style: { width: '50%', paddingRight: '2%' } },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'col-md-12 col-sm-12 col-xs-12', style: { position: 'static' } },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.description },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'p',
								{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading },
								'Summary '
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ style: { position: 'absolute' } },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'a',
									{ onClick: function onClick() {
											return _this2.setState({ showText: !_this2.state.showText });
										} },
									this.state.showText ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCircle },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'span',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.minusSign },
											'\u2013'
										)
									) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCircle },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'span',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.plusSign },
											'+'
										)
									)
								)
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ style: { marginLeft: '8%' } },
								!this.state.showText ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'span',
									{ style: { color: '#191818' } },
									this.props.projectDetail.project.description && this.props.projectDetail.project.description.split(" ").splice(0, 9).join(" "),
									'  '
								) : null,
								this.state.showText ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'p',
									null,
									this.props.projectDetail.project.description.split('\n').map(function (item, key) {
										return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'span',
											{ key: key },
											item,
											_ref
										);
									})
								) : null
							)
						),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.projectStatus },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__components_project_timeline__["a" /* default */], { data: this.props.projectDetail.time_line }),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.arealChart },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading, style: (_ref2 = { marginTop: '10px' }, _ref2['marginTop'] = '25px', _ref2) },
									_ref3
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.areaHeaderWrapper },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legendWrapper },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legendItemOuterWrapper },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legendItemInnerWrapper },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'div',
													{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.itemAlignmentWrapper },
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legend + ' ' + __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.budgetLegend + ' ' }),
													_ref4
												)
											),
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legendItemInnerWrapper },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'div',
													{ className: __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.itemAlignmentWrapper },
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.legend + ' ' + __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.revenueLegend + ' ' }),
													_ref5
												)
											)
										)
									)
								),
								_ref6
							)
						)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ style: { width: '50%' } },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'section',
						null,
						this.state.expand ? this.state.mapType !== 'map' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__downloadModal__["a" /* default */], { onCloseModal: function onCloseModal() {
								return _this2.closeModal();
							}, mapType: this.state.mapType, satelliteData: this.props.satelliteData, currentLocationIndex: this.currentLocationIndex, changeSource: function changeSource(index) {
								return _this2.changeSatelliteSrc(index);
							} })
						// <DownloadModal onCloseModal={() => this.closeModal()} mapType = {this.state.mapType} projectId={this.props.projectId} projectDetailMapData = {data} />
						: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__downloadModal__["a" /* default */], { onCloseModal: function onCloseModal() {
								return _this2.closeModal();
							}, mapType: this.state.mapType, projectId: this.props.projectId, projectDetailMapData: props.projectDetailMapData }) : null
					),
					isProjectDetailNonEmpty && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'col-md-12 col-sm-12 col-xs-12' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10_preact_helmet___default.a, {
							meta: [{ name: 'description', content: this.props.projectDetail.project.description }, { property: 'og:description', content: this.props.projectDetail.project.description }, { property: 'twitter:description', content: this.props.projectDetail.project.description }]
						}),
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': '' + __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.descriptionSection },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.description },
								this.props.projectDetail.project.description_type2 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									null,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'p',
										{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading },
										'Objectives'
									),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ style: { position: 'absolute' } },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'a',
											{ onClick: function onClick() {
													return _this2.setState({ showTextDesc2: !_this2.state.showTextDesc2 });
												} },
											this.state.showTextDesc2 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCircle },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'span',
													{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.minusSign },
													'\u2013'
												)
											) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCircle },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'span',
													{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.plusSign },
													'+'
												)
											)
										)
									),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ style: { marginLeft: '6%' } },
										!this.state.showTextDesc2 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'span',
											{ style: { color: '#191818' } },
											this.props.projectDetail.project.description_type2 && this.props.projectDetail.project.description_type2.split(" ").splice(0, 9).join(" "),
											'  '
										) : null,
										this.state.showTextDesc2 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'p',
											null,
											this.props.projectDetail.project.description_type2.split('\n').map(function (item, key) {
												return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'span',
													{ key: key },
													item,
													_ref7
												);
											})
										) : null
									)
								) : null
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.mapArea },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.description, style: { margin: '0px', paddingBottom: '20px', borderTopLeftRadius: '14px', borderTopRightRadius: '14px', borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px' } },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'p',
										{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading },
										'Recipient Country / Region',
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'section',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.mapOptions, style: { position: 'relative', float: 'right' } },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'section',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.mapMenu },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.expandButton, src: './../../static/assets/icons/expand.svg', onClick: function onClick() {
														return _this2.openModal(_this2.state.mapType);
													} })
											)
										)
									),
									this.countryRegionList(this.props.mapCountryData && this.props.mapCountryData.outputData && this.props.mapCountryData.outputData.data)
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ style: { 'padding-top': '0px' }, 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.projectMap },
									this.state.mapType === 'map' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__components_map__["a" /* default */], {
										clusterMode: true,
										projectId: this.props.projectId,
										mapData: this.props.projectDetailMapData,
										mapId: 'individualProjectMap',
										autoCenter: true
									}) : this.props.satelliteData.length ? _ref8 : _ref9
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.disclaimer },
									'* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'
								)
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.description },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'p',
									{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.heading },
									'Implementing Partners'
								),
								this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_members'].length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									null,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'a',
										{ onClick: function onClick() {
												return _this2.setState({ iucnMember: !_this2.state.iucnMember });
											} },
										this.state.iucnMember ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCirclePartner },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'span',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.minusSign },
												'\u2013'
											)
										) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCirclePartner },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'span',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.plusSign },
												'+'
											)
										),
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'p',
											{ style: { marginLeft: '33px', 'postions': 'absolute', color: '#000' } },
											'IUCN member'
										)
									),
									this.state.iucnMember ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'span',
										null,
										this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_members'].join(', ')
									) : null
								) : null,
								this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_nonmembers'].length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									null,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'a',
										{ onClick: function onClick() {
												return _this2.setState({ iucnNonMember: !_this2.state.iucnNonMember });
											} },
										this.state.iucnNonMember ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCirclePartner },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'span',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.minusSign },
												'\u2013'
											)
										) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.cssCirclePartner },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'span',
												{ 'class': __WEBPACK_IMPORTED_MODULE_11__style_scss___default.a.plusSign },
												'+'
											)
										),
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'p',
											{ style: { marginLeft: '33px', 'postions': 'absolute', color: '#000' } },
											'IUCN non member'
										)
									),
									this.state.iucnNonMember ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'span',
										null,
										this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_nonmembers'].join(', ')
									) : null
								) : null
							)
						)
					)
				)
			)
		);
	};

	return ProjectDescription;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
	var projectDetailMapData = state.mapData.projectDetailMapData;

	var mapCountryData = state.mapData;
	return {
		projectDetail: state.projectDetail,
		projectDetailMapData: projectDetailMapData,
		mapCountryData: mapCountryData
	};
};

var mapDispatch = function mapDispatch(dispatch) {
	return {};
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_preact_redux__["a" /* connect */])(mapStateToProps, mapDispatch)(ProjectDescription));

/***/ }),

/***/ "YZJ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"progressBar":"progressBar__18wql","progressBarChild":"progressBarChild__3cqRJ","bar_step":"bar_step__ZPSR6","label_line":"label_line__1G6cT","label_txt":"label_txt__THHQn","label_percent":"label_percent__sqJK0","dateWrapper":"dateWrapper___Zw9E","timeLine":"timeLine__17LEM","timeLineWrapper":"timeLineWrapper__3oWjV","headingTimeline":"headingTimeline__id374"};

/***/ }),

/***/ "ai+R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__RDYLe","list_wrapper":"list_wrapper__ZdUwn","legendOuterWrapper":"legendOuterWrapper__wuGF7","legendInnerWrapper":"legendInnerWrapper__7mLNu","contributionWrapper":"contributionWrapper__21hLB","wrapperItem":"wrapperItem__1esnl","DonorContribution":"DonorContribution___fMHw","allDonorContribution":"allDonorContribution__3SAwD","contributionText":"contributionText__1BrzX"};

/***/ }),

/***/ "dIRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export purchaseOrderData */
var purchaseOrderData = [{
  poId: "21336",
  vendor: "DAN Office",
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  date: 'Nov 11, 2017',
  amount: '32000000.00'
}, {
  poId: "21337",
  vendor: "DAN Office",
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  date: 'Nov 11, 2017',
  amount: '64000000.00'
}, {
  poId: "21338",
  vendor: "DAN Office",
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  date: 'Nov 11, 2017',
  amount: '76000000.00'
}];

/***/ }),

/***/ "gxLQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1pDhJ","donutChartWrapper":"donutChartWrapper__1_HLR","donuttopWrapper":"donuttopWrapper__2OpZD","barChartWrapper":"barChartWrapper__2qFpd","preLoaderWrapper":"preLoaderWrapper__25rzu","noDataTemplateWrapper":"noDataTemplateWrapper__3htBj","textWrapperStyle":"textWrapperStyle__2lc_A","headerWrapper":"headerWrapper__2xjsg","recipientProfileChartHeaderInfo":"recipientProfileChartHeaderInfo__SrtdQ","textFieldStyle":"textFieldStyle__Ti-eE"};

/***/ }),

/***/ "lKgI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tabSwitch":"tabSwitch__9EabM","list":"list__Of9QD","active":"active__3miGe","POWrapper":"POWrapper__3ydRv","accordionItem":"accordionItem__3hMTY","tooltipPO":"tooltipPO__1fjCz","mobile":"mobile__3gtRZ","desktop":"desktop__1MQyp","accordionScroll":"accordionScroll__2egUv","accordion":"accordion__25CVk","accordionPosition":"accordionPosition__G0CH2","scrollWrapper":"scrollWrapper__3I-tp","accordionContent":"accordionContent__5rA9K","accordionHead":"accordionHead__34Efy","accordionTitle":"accordionTitle__187mW","accordionSelected":"accordionSelected__15PtP","filterIcon":"filterIcon__3GHIu","mapIcon":"mapIcon__1xoaL","embedSection":"embedSection__2_zUd","exportSection":"exportSection__3D07Y"};

/***/ }),

/***/ "pWm/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"projectTablesection":"projectTablesection__2KEfi","breadCrumbWrapper":"breadCrumbWrapper__2sp_7","desktopTable":"desktopTable__1OCeP","mapWrapper":"mapWrapper__39OGe","wrapper":"wrapper__ueLiz","galleryWrapper":"galleryWrapper__3qXEv","gallerOuter":"gallerOuter__3blMf","galleryHeading":"galleryHeading__1eIl_","deliveryModelComponentWrapper":"deliveryModelComponentWrapper__2pLwl","deliveryModelWrapper":"deliveryModelWrapper__133AY","deliveryModelHeading":"deliveryModelHeading__RESrb","deliveryModelProjectWrapper":"deliveryModelProjectWrapper__WYhTi"};

/***/ }),

/***/ "pqrH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PurchaseOrderTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("+Un9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__ = __webpack_require__("X5Y7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal__ = __webpack_require__("Dpjs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_icons_closeIcon_png__ = __webpack_require__("k8Z6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_assets_icons_closeIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_assets_icons_closeIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_assets_json_projectDetailDocuments__ = __webpack_require__("CamH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dropList__ = __webpack_require__("wdAp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__preLoader__ = __webpack_require__("ufjx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tableCards__ = __webpack_require__("3y4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dateFormatter__ = __webpack_require__("GXBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__no_data_template__ = __webpack_require__("wdDn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_numberFormatter__ = __webpack_require__("Au7/");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DocumentCategoryList = ["sdvksdgs", "svkjdhsg"];

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__preLoader__["a" /* default */], null);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10__no_data_template__["a" /* default */], null);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('link', { rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css' });

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
    {
        width: '10%',
        isKey: true,
        dataField: 'order_id' },
    'PO ID'
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
    { width: '20%',
        dataField: 'vendor_name' },
    'Vendor'
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
    { width: '30%',
        dataField: 'description' },
    'Description'
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7__preLoader__["a" /* default */], null);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10__no_data_template__["a" /* default */], null);

var PurchaseOrderTable = function (_Component) {
    _inherits(PurchaseOrderTable, _Component);

    function PurchaseOrderTable(props) {
        _classCallCheck(this, PurchaseOrderTable);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.currencyFormat = function (cell, row) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.priceColumn },
                Object(__WEBPACK_IMPORTED_MODULE_11__utils_numberFormatter__["e" /* numberToDollarFormatter */])(cell)
            );
        };

        _this.dateFormat = function (cell, row) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_9__utils_dateFormatter__["a" /* getFormmattedDate */])(cell)
            );
        };

        _this.parseTableData = function () {
            var obj = {
                order_id: "PO ID",
                vendor_name: "Vendor",
                description: "Description",
                order_date: "Date",
                amount: "Amount"
            };
            var formattedarray = _this.props.data.map(function (item) {
                return _extends({}, item, {
                    order_date: Object(__WEBPACK_IMPORTED_MODULE_9__utils_dateFormatter__["a" /* getFormmattedDate */])(item.order_date),
                    amount: Object(__WEBPACK_IMPORTED_MODULE_11__utils_numberFormatter__["e" /* numberToDollarFormatter */])(item.amount)
                });
            });
            return [obj].concat(formattedarray);
        };

        _this.onMaximize = function () {
            _this.setState({ showMore: false });
        };

        _this.generateCardList = function (dataArray) {
            if (dataArray.length) {
                return dataArray.map(function (item) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__tableCards__["a" /* default */], {
                        data: item,
                        fields: [{
                            title: 'TITILE',
                            key: 'vendor_name',
                            displayTitle: false,
                            renderElement: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'div',
                                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.vendorWrapper },
                                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                    'div',
                                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.docCategorylabel },
                                    'Vendor :'
                                ),
                                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                    'div',
                                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.docCategorytext },
                                    item.vendor_name
                                )
                            )

                        }, {
                            title: 'ID',
                            key: 'order_id',
                            displayTitle: false,
                            renderElement: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'div',
                                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.projectId },
                                '# ' + item.project_id
                            )
                        }, {
                            title: 'COUNTRY',
                            key: 'description',
                            displayTitle: false,
                            renderElement: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'div',
                                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.purchaseOrderDescription },
                                item.description
                            )

                        }, {
                            title: 'BUDGET',
                            key: 'order_date',
                            displayTitle: false,
                            renderElement: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                'div',
                                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.amountDateWrapper },
                                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                    'div',
                                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.amount },
                                    Object(__WEBPACK_IMPORTED_MODULE_9__utils_dateFormatter__["a" /* getFormmattedDate */])(item.order_date)
                                ),
                                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                                    'div',
                                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.date },
                                    Object(__WEBPACK_IMPORTED_MODULE_11__utils_numberFormatter__["e" /* numberToDollarFormatter */])(item.amount)
                                )
                            )

                        }] });
                });
            } else {
                return [];
            }
        };

        _this.state = {
            showMore: props.data.length <= 20 ? false : true
        };
        _this.data = [{
            order_id: 'dssvdsvd',
            vendor_name: 'dsdvdsvdsvdd',
            description: 'ddsvdsvdsvd',
            order_date: 'ddsdvdsvdv',
            amount: 'ssssdvdsvdsv'
        }];
        return _this;
    }

    PurchaseOrderTable.prototype.componentDidMount = function componentDidMount() {
        if (this.props.data.length <= 20) this.setState({ showMore: false });else this.setState({ showMore: true });
    };

    PurchaseOrderTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.data.length <= 20) this.setState({ showMore: false });else this.setState({ showMore: true });
    };

    PurchaseOrderTable.prototype.render = function render(_ref, state) {
        var _this2 = this;

        var data = _ref.data;

        var options = {
            noDataText: this.props.loading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.preloaderWrapper },
                _ref2
            ) : _ref3
        };
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.projectList + ' ' + __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableOuterWrapper },
                _ref4,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["BootstrapTable"],
                    {
                        data: !this.props.loading ? this.state.showMore === false ? data : data.slice(0, 20) : [],
                        options: options,
                        bordered: true,
                        version: '4',
                        headerContainerClass: __WEBPACK_IMPORTED_MODULE_1__style___default.a.headerContainerClass,
                        headerStyle: { borderBottom: 0, background: '#fffff' },
                        bodyStyle: { height: 'auto', background: '#f4f5fa', marginBottom: 0, paddingRight: 0 },
                        tableBodyClass: __WEBPACK_IMPORTED_MODULE_1__style___default.a.tableBodyClass,
                        containerClass: __WEBPACK_IMPORTED_MODULE_1__style___default.a.containerClass
                    },
                    _ref5,
                    _ref6,
                    _ref7,
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
                        { width: '20%',
                            dataField: 'order_date',
                            dataFormat: this.dateFormat
                        },
                        'Date'
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_table__["TableHeaderColumn"],
                        { width: '20%',
                            dataFormat: this.currencyFormat,
                            dataField: 'amount'
                        },
                        'Amount'
                    )
                )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.cardListOuterWrapper },
                this.props.loading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.preloaderWrapper },
                    _ref8
                ) : data.length ? this.generateCardList(data) : _ref9
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.loadWrapper },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'button',
                    { 'class': this.state.showMore === true ? __WEBPACK_IMPORTED_MODULE_1__style___default.a.buttons : __WEBPACK_IMPORTED_MODULE_1__style___default.a.hideButtons,
                        onClick: function onClick() {
                            return _this2.onMaximize();
                        }
                    },
                    'Load more..'
                )
            )
        );
    };

    return PurchaseOrderTable;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "q4r3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1M__r","innerContainer":"innerContainer__MlaBb","cardDetails":"cardDetails__2_ce0","title":"title__U45Pv","projectId":"projectId__1cggV","description":"description__1nvZ1","value":"value__yzMUL","sdgData":"sdgData__31Ktd","resultsWrapper":"resultsWrapper__ESYSE","results":"results__9FQA9","lessDetails":"lessDetails__-GYlz","lessDetailsText":"lessDetailsText__HEjZp","lessDetailImage":"lessDetailImage__2WbAA","moreDetailImage":"moreDetailImage__BnlNM","genderEquality":"genderEquality__2VkMu","heading":"heading__2LDYK","budgetSources":"budgetSources__2q1Th","header":"header__1RgN3","subheader":"subheader__1fRL2","sub_section":"sub_section__2s_Qs","bullet":"bullet__35Zuq","budgetSourcesHeading":"budgetSourcesHeading__GGslo","policyMarkerSection":"policyMarkerSection__1qqgq","policyMarker":"policyMarker__LO4rO","policyMarkerHeading":"policyMarkerHeading__D5IKw","view_results":"view_results__3cpxY","budgetTable":"budgetTable__vQKia"};

/***/ }),

/***/ "r7Tw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__("eW0v");

var DetectPassiveEvents = __webpack_require__("O8Wv").default;

function getInitialState() {
  return {
    x: null,
    y: null,
    swiping: false,
    start: 0
  };
}

function getMovingPosition(e) {
  return 'changedTouches' in e ? { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY } : { x: e.clientX, y: e.clientY };
}
function getPosition(e) {
  return 'touches' in e ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY };
}

function calculatePos(e, state) {
  var _getMovingPosition = getMovingPosition(e),
      x = _getMovingPosition.x,
      y = _getMovingPosition.y;

  var deltaX = state.x - x;
  var deltaY = state.y - y;

  var absX = Math.abs(deltaX);
  var absY = Math.abs(deltaY);

  var time = Date.now() - state.start;
  var velocity = Math.sqrt(absX * absX + absY * absY) / time;

  return { deltaX: deltaX, deltaY: deltaY, absX: absX, absY: absY, velocity: velocity };
}

var Swipeable = function (_React$Component) {
  _inherits(Swipeable, _React$Component);

  function Swipeable(props, context) {
    _classCallCheck(this, Swipeable);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.eventStart = _this.eventStart.bind(_this);
    _this.eventMove = _this.eventMove.bind(_this);
    _this.eventEnd = _this.eventEnd.bind(_this);
    _this.mouseDown = _this.mouseDown.bind(_this);
    _this.mouseMove = _this.mouseMove.bind(_this);
    _this.mouseUp = _this.mouseUp.bind(_this);
    _this.cleanupMouseListeners = _this.cleanupMouseListeners.bind(_this);
    _this.setupMouseListeners = _this.setupMouseListeners.bind(_this);
    _this.elementRef = _this.elementRef.bind(_this);
    _this.setupTouchmoveEvent = _this.setupTouchmoveEvent.bind(_this);
    _this.cleanupTouchmoveEvent = _this.cleanupTouchmoveEvent.bind(_this);
    _this.hasPassiveSupport = DetectPassiveEvents.hasSupport;
    return _this;
  }

  Swipeable.prototype.componentWillMount = function componentWillMount() {
    this.swipeable = getInitialState();
  };

  Swipeable.prototype.componentDidMount = function componentDidMount() {
    if (this.props.preventDefaultTouchmoveEvent) {
      this.setupTouchmoveEvent();
    }
  };

  Swipeable.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.disabled !== this.props.disabled) {
      this.cleanupMouseListeners();

      this.swipeable = getInitialState();
    }

    if (prevProps.preventDefaultTouchmoveEvent && !this.props.preventDefaultTouchmoveEvent) {
      this.cleanupTouchmoveEvent();
    } else if (!prevProps.preventDefaultTouchmoveEvent && this.props.preventDefaultTouchmoveEvent) {
      this.setupTouchmoveEvent();
    }
  };

  Swipeable.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cleanupMouseListeners();
  };

  Swipeable.prototype.setupTouchmoveEvent = function setupTouchmoveEvent() {
    if (this.element && this.hasPassiveSupport) {
      this.element.addEventListener('touchmove', this.eventMove, { passive: false });
    }
  };

  Swipeable.prototype.setupMouseListeners = function setupMouseListeners() {
    document.addEventListener('mousemove', this.mouseMove);
    document.addEventListener('mouseup', this.mouseUp);
  };

  Swipeable.prototype.cleanupTouchmoveEvent = function cleanupTouchmoveEvent() {
    if (this.element && this.hasPassiveSupport) {
      this.element.removeEventListener('touchmove', this.eventMove, { passive: false });
    }
  };

  Swipeable.prototype.cleanupMouseListeners = function cleanupMouseListeners() {
    document.removeEventListener('mousemove', this.mouseMove);
    document.removeEventListener('mouseup', this.mouseUp);
  };

  Swipeable.prototype.mouseDown = function mouseDown(e) {
    if (!this.props.trackMouse || e.type !== 'mousedown') {
      return;
    }

    if (typeof this.props.onMouseDown === 'function') this.props.onMouseDown(e);

    this.setupMouseListeners();

    this.eventStart(e);
  };

  Swipeable.prototype.mouseMove = function mouseMove(e) {
    this.eventMove(e);
  };

  Swipeable.prototype.mouseUp = function mouseUp(e) {
    this.cleanupMouseListeners();
    this.eventEnd(e);
  };

  Swipeable.prototype.eventStart = function eventStart(e) {
    if (e.touches && e.touches.length > 1) return;

    var _getPosition = getPosition(e),
        x = _getPosition.x,
        y = _getPosition.y;

    if (this.props.stopPropagation) e.stopPropagation();

    this.swipeable = { start: Date.now(), x: x, y: y, swiping: false };
  };

  Swipeable.prototype.eventMove = function eventMove(e) {
    var _props = this.props,
        stopPropagation = _props.stopPropagation,
        delta = _props.delta,
        onSwiping = _props.onSwiping,
        onSwipingLeft = _props.onSwipingLeft,
        onSwipedLeft = _props.onSwipedLeft,
        onSwipingRight = _props.onSwipingRight,
        onSwipedRight = _props.onSwipedRight,
        onSwipingUp = _props.onSwipingUp,
        onSwipedUp = _props.onSwipedUp,
        onSwipingDown = _props.onSwipingDown,
        onSwipedDown = _props.onSwipedDown,
        preventDefaultTouchmoveEvent = _props.preventDefaultTouchmoveEvent;

    if (!this.swipeable.x || !this.swipeable.y || e.touches && e.touches.length > 1) {
      return;
    }

    var pos = calculatePos(e, this.swipeable);

    if (pos.absX < delta && pos.absY < delta && !this.swipeable.swiping) return;

    if (stopPropagation) e.stopPropagation();

    if (onSwiping) {
      onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY, pos.velocity);
    }

    var cancelablePageSwipe = false;
    if (pos.absX > pos.absY) {
      if (pos.deltaX > 0) {
        if (onSwipingLeft || onSwipedLeft) {
          onSwipingLeft && onSwipingLeft(e, pos.absX);
          cancelablePageSwipe = true;
        }
      } else if (onSwipingRight || onSwipedRight) {
        onSwipingRight && onSwipingRight(e, pos.absX);
        cancelablePageSwipe = true;
      }
    } else if (pos.deltaY > 0) {
      if (onSwipingUp || onSwipedUp) {
        onSwipingUp && onSwipingUp(e, pos.absY);
        cancelablePageSwipe = true;
      }
    } else if (onSwipingDown || onSwipedDown) {
      onSwipingDown && onSwipingDown(e, pos.absY);
      cancelablePageSwipe = true;
    }

    this.swipeable.swiping = true;

    if (cancelablePageSwipe && preventDefaultTouchmoveEvent) e.preventDefault();
  };

  Swipeable.prototype.eventEnd = function eventEnd(e) {
    var _props2 = this.props,
        stopPropagation = _props2.stopPropagation,
        flickThreshold = _props2.flickThreshold,
        onSwiped = _props2.onSwiped,
        onSwipedLeft = _props2.onSwipedLeft,
        onSwipedRight = _props2.onSwipedRight,
        onSwipedUp = _props2.onSwipedUp,
        onSwipedDown = _props2.onSwipedDown,
        onTap = _props2.onTap;

    if (this.swipeable.swiping) {
      var pos = calculatePos(e, this.swipeable);

      if (stopPropagation) e.stopPropagation();

      var isFlick = pos.velocity > flickThreshold;

      onSwiped && onSwiped(e, pos.deltaX, pos.deltaY, isFlick, pos.velocity);

      if (pos.absX > pos.absY) {
        if (pos.deltaX > 0) {
          onSwipedLeft && onSwipedLeft(e, pos.deltaX, isFlick);
        } else {
          onSwipedRight && onSwipedRight(e, pos.deltaX, isFlick);
        }
      } else if (pos.deltaY > 0) {
        onSwipedUp && onSwipedUp(e, pos.deltaY, isFlick);
      } else {
        onSwipedDown && onSwipedDown(e, pos.deltaY, isFlick);
      }
    } else {
      onTap && onTap(e);
    }

    this.swipeable = getInitialState();
  };

  Swipeable.prototype.elementRef = function elementRef(element) {
    this.element = element;
    this.props.innerRef && this.props.innerRef(element);
  };

  Swipeable.prototype.render = function render() {
    var newProps = _extends({}, this.props);
    if (!this.props.disabled) {
      newProps.onTouchStart = this.eventStart;

      if (!this.props.preventDefaultTouchmoveEvent || !this.hasPassiveSupport) {
        newProps.onTouchMove = this.eventMove;
      }

      newProps.onTouchEnd = this.eventEnd;
      newProps.onMouseDown = this.mouseDown;
    }

    newProps.ref = this.elementRef;

    delete newProps.onSwiped;
    delete newProps.onSwiping;
    delete newProps.onSwipingUp;
    delete newProps.onSwipingRight;
    delete newProps.onSwipingDown;
    delete newProps.onSwipingLeft;
    delete newProps.onSwipedUp;
    delete newProps.onSwipedRight;
    delete newProps.onSwipedDown;
    delete newProps.onSwipedLeft;
    delete newProps.onTap;
    delete newProps.flickThreshold;
    delete newProps.delta;
    delete newProps.preventDefaultTouchmoveEvent;
    delete newProps.stopPropagation;
    delete newProps.nodeName;
    delete newProps.children;
    delete newProps.trackMouse;
    delete newProps.disabled;
    delete newProps.innerRef;

    return React.createElement(this.props.nodeName, newProps, this.props.children);
  };

  return Swipeable;
}(React.Component);

Swipeable.defaultProps = {
  flickThreshold: 0.6,
  delta: 10,
  preventDefaultTouchmoveEvent: false,
  stopPropagation: false,
  nodeName: 'div',
  disabled: false
};

module.exports = Swipeable;

/***/ }),

/***/ "sqGb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"budgetDot":"budgetDot__iBcfy","area_chart":"area_chart__3_b1N","tooltip":"tooltip__3Fjv-","contentWrapper":"contentWrapper__2bdyH","markerWrapper":"markerWrapper__3rnTP","budgetMarker":"budgetMarker__e5Ub8","expenseMarker":"expenseMarker__2r1PW","expenseWrapper":"expenseWrapper__Er7s2","yearDisplay":"yearDisplay__1f54w","chart_area1":"chart_area1__1I0kp","line_chart1":"line_chart1__2kD7p","line_chart2":"line_chart2__1yhq2","chart_area2":"chart_area2__1A_mX","xaxis":"xaxis__3u4zJ","yaxis":"yaxis__1ZQwO","svgIe":"svgIe__22DaN"};

/***/ }),

/***/ "uq96":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _reactSwipeable = __webpack_require__("r7Tw");

var _reactSwipeable2 = _interopRequireDefault(_reactSwipeable);

var _lodash = __webpack_require__("FNy/");

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__("4PZ+");

var _lodash4 = _interopRequireDefault(_lodash3);

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var screenChangeEvents = ['fullscreenchange', 'MSFullscreenChange', 'mozfullscreenchange', 'webkitfullscreenchange'];

var ImageGallery = function (_React$Component) {
  _inherits(ImageGallery, _React$Component);

  function ImageGallery(props) {
    _classCallCheck(this, ImageGallery);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ImageGallery).call(this, props));

    _this.slideToIndex = function (index, event) {
      var _this$state = _this.state;
      var currentIndex = _this$state.currentIndex;
      var isTransitioning = _this$state.isTransitioning;

      if (!isTransitioning) {
        if (event) {
          if (_this._intervalId) {
            // user triggered event while ImageGallery is playing, reset interval
            _this.pause(false);
            _this.play(false);
          }
        }

        var slideCount = _this.props.items.length - 1;
        var nextIndex = index;

        if (index < 0) {
          nextIndex = slideCount;
        } else if (index > slideCount) {
          nextIndex = 0;
        }

        _this.setState({
          previousIndex: currentIndex,
          currentIndex: nextIndex,
          isTransitioning: nextIndex !== currentIndex,
          offsetPercentage: 0,
          style: {
            transition: 'all ' + _this.props.slideDuration + 'ms ease-out'
          }
        }, _this._onSliding);
      }
    };

    _this._onSliding = function () {
      var isTransitioning = _this.state.isTransitioning;

      window.setTimeout(function () {
        if (isTransitioning) {
          _this.setState({ isTransitioning: !isTransitioning });
        }
      }, _this.props.slideDuration + 50);
    };

    _this._handleScreenChange = function () {
      /*
        handles screen change events that the browser triggers e.g. esc key
      */
      var fullScreenElement = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;

      if (_this.props.onScreenChange) {
        _this.props.onScreenChange(fullScreenElement);
      }

      _this.setState({ isFullscreen: !!fullScreenElement });
    };

    _this._toggleFullScreen = function () {
      if (_this.state.isFullscreen) {
        _this.exitFullScreen();
      } else {
        _this.fullScreen();
      }
    };

    _this._togglePlay = function () {
      if (_this._intervalId) {
        _this.pause();
      } else {
        _this.play();
      }
    };

    _this._handleResize = function () {
      // delay initial resize to get the accurate this._imageGallery height/width
      _this._resizeTimer = window.setTimeout(function () {
        if (_this._imageGallery) {
          _this.setState({
            galleryWidth: _this._imageGallery.offsetWidth
          });
        }

        // adjust thumbnail container when thumbnail width or height is adjusted
        _this._setThumbsTranslate(-_this._getThumbsTranslate(_this.state.currentIndex > 0 ? 1 : 0) * _this.state.currentIndex);

        if (_this._imageGallerySlideWrapper) {
          _this.setState({
            gallerySlideWrapperHeight: _this._imageGallerySlideWrapper.offsetHeight
          });
        }

        if (_this._thumbnailsWrapper) {
          if (_this._isThumbnailHorizontal()) {
            _this.setState({ thumbnailsWrapperHeight: _this._thumbnailsWrapper.offsetHeight });
          } else {
            _this.setState({ thumbnailsWrapperWidth: _this._thumbnailsWrapper.offsetWidth });
          }
        }
      }, 50);
    };

    _this._handleKeyDown = function (event) {
      var LEFT_ARROW = 37;
      var RIGHT_ARROW = 39;
      var ESC_KEY = 27;
      var key = parseInt(event.keyCode || event.which || 0);

      switch (key) {
        case LEFT_ARROW:
          if (_this._canSlideLeft() && !_this._intervalId) {
            _this._slideLeft();
          }
          break;
        case RIGHT_ARROW:
          if (_this._canSlideRight() && !_this._intervalId) {
            _this._slideRight();
          }
          break;
        case ESC_KEY:
          if (_this.state.isFullscreen && !_this.props.useBrowserFullscreen) {
            _this.exitFullScreen();
          }
      }
    };

    _this._handleMouseLeaveThumbnails = function () {
      if (_this._thumbnailTimer) {
        window.clearTimeout(_this._thumbnailTimer);
        _this._thumbnailTimer = null;
        if (_this.props.autoPlay === true) {
          _this.play(false);
        }
      }
      _this.setState({ hovering: false });
    };

    _this._handleImageError = function (event) {
      if (_this.props.defaultImage && event.target.src.indexOf(_this.props.defaultImage) === -1) {
        event.target.src = _this.props.defaultImage;
      }
    };

    _this._handleOnSwiped = function (e, deltaX, deltaY, isFlick) {
      var _this$state2 = _this.state;
      var scrollingUpDown = _this$state2.scrollingUpDown;
      var scrollingLeftRight = _this$state2.scrollingLeftRight;

      if (scrollingUpDown) {
        // user stopped scrollingUpDown
        _this.setState({ scrollingUpDown: false });
      }

      if (scrollingLeftRight) {
        // user stopped scrollingLeftRight
        _this.setState({ scrollingLeftRight: false });
      }

      if (!scrollingUpDown) {
        // don't swipe if user is scrolling
        var side = deltaX > 0 ? 1 : -1;
        _this._handleOnSwipedTo(side, isFlick);
      }
    };

    _this._handleSwiping = function (e, deltaX, deltaY, delta) {
      var _this$state3 = _this.state;
      var galleryWidth = _this$state3.galleryWidth;
      var isTransitioning = _this$state3.isTransitioning;
      var scrollingUpDown = _this$state3.scrollingUpDown;
      var swipingTransitionDuration = _this.props.swipingTransitionDuration;

      _this._setScrollDirection(deltaX, deltaY);
      if (!isTransitioning && !scrollingUpDown) {
        var side = deltaX < 0 ? 1 : -1;

        var offsetPercentage = delta / galleryWidth * 100;
        if (Math.abs(offsetPercentage) >= 100) {
          offsetPercentage = 100;
        }

        var swipingTransition = {
          transition: 'transform ' + swipingTransitionDuration + 'ms ease-out'
        };

        _this.setState({
          offsetPercentage: side * offsetPercentage,
          style: swipingTransition
        });
      } else {
        // don't move the slide
        _this.setState({ offsetPercentage: 0 });
      }
    };

    _this._slideLeft = function (event) {
      _this.slideToIndex(_this.state.currentIndex - 1, event);
    };

    _this._slideRight = function (event) {
      _this.slideToIndex(_this.state.currentIndex + 1, event);
    };

    _this._renderItem = function (item) {
      var onImageError = _this.props.onImageError || _this._handleImageError;

      return _react2.default.createElement('div', { className: 'image-gallery-image' }, item.imageSet ? _react2.default.createElement('picture', {
        onLoad: _this.props.onImageLoad,
        onError: onImageError
      }, item.imageSet.map(function (source, index) {
        return _react2.default.createElement('source', {
          key: index,
          media: source.media,
          srcSet: source.srcSet
        });
      }), _react2.default.createElement('img', {
        alt: item.originalAlt,
        src: item.original
      })) : _react2.default.createElement('img', {
        src: item.original,
        alt: item.originalAlt,
        srcSet: item.srcSet,
        sizes: item.sizes,
        title: item.originalTitle,
        onLoad: _this.props.onImageLoad,
        onError: onImageError
      }), item.description && _react2.default.createElement('span', { className: 'image-gallery-description' }, item.description));
    };

    _this._renderThumbInner = function (item) {
      var onThumbnailError = _this.props.onThumbnailError || _this._handleImageError;

      return _react2.default.createElement('div', null, _react2.default.createElement('img', {
        src: item.thumbnail,
        alt: item.thumbnailAlt,
        title: item.thumbnailTitle,
        onError: onThumbnailError
      }), _react2.default.createElement('div', { className: 'image-gallery-thumbnail-label' }, item.thumbnailLabel));
    };

    _this.state = {
      currentIndex: props.startIndex,
      thumbsTranslate: 0,
      offsetPercentage: 0,
      galleryWidth: 0,
      thumbnailsWrapperWidth: 0,
      thumbnailsWrapperHeight: 0,
      isFullscreen: false,
      isPlaying: false
    };

    if (props.lazyLoad) {
      _this._lazyLoaded = [];
    }
    return _this;
  }

  _createClass(ImageGallery, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.disableArrowKeys !== nextProps.disableArrowKeys) {
        if (nextProps.disableArrowKeys) {
          window.removeEventListener('keydown', this._handleKeyDown);
        } else {
          window.addEventListener('keydown', this._handleKeyDown);
        }
      }

      if (nextProps.lazyLoad && (!this.props.lazyLoad || this.props.items !== nextProps.items)) {
        this._lazyLoaded = [];
      }

      if (this.state.currentIndex >= nextProps.items.length) {
        this.slideToIndex(0);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.thumbnailPosition !== this.props.thumbnailPosition || prevProps.showThumbnails !== this.props.showThumbnails || prevState.thumbnailsWrapperHeight !== this.state.thumbnailsWrapperHeight || prevState.thumbnailsWrapperWidth !== this.state.thumbnailsWrapperWidth) {
        this._handleResize();
      }

      if (prevState.currentIndex !== this.state.currentIndex) {
        if (this.props.onSlide) {
          this.props.onSlide(this.state.currentIndex);
        }

        this._updateThumbnailTranslate(prevState);
      }

      if (prevProps.slideDuration !== this.props.slideDuration) {
        this.slideToIndex = (0, _lodash2.default)(this._unthrottledSlideToIndex, this.props.slideDuration, { trailing: false });
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Used to update the throttle if slideDuration changes
      this._unthrottledSlideToIndex = this.slideToIndex;
      this.slideToIndex = (0, _lodash2.default)(this._unthrottledSlideToIndex, this.props.slideDuration, { trailing: false });

      this._handleResize = this._handleResize;
      this._debounceResize = (0, _lodash4.default)(this._handleResize, 500);
      this._handleScreenChange = this._handleScreenChange;
      this._thumbnailDelay = 300;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._handleResize();

      if (this.props.autoPlay) {
        this.play();
      }
      if (!this.props.disableArrowKeys) {
        window.addEventListener('keydown', this._handleKeyDown);
      }
      window.addEventListener('resize', this._debounceResize);
      this._onScreenChangeEvent();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.props.disableArrowKeys) {
        window.removeEventListener('keydown', this._handleKeyDown);
      }

      if (this._debounceResize) {
        window.removeEventListener('resize', this._debounceResize);
        this._debounceResize.cancel();
      }

      this._offScreenChangeEvent();

      if (this._intervalId) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
      }

      if (this._resizeTimer) {
        window.clearTimeout(this._resizeTimer);
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var _this2 = this;

      var callback = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (!this._intervalId) {
        var _props = this.props;
        var slideInterval = _props.slideInterval;
        var slideDuration = _props.slideDuration;

        this.setState({ isPlaying: true });
        this._intervalId = window.setInterval(function () {
          if (!_this2.state.hovering) {
            if (!_this2.props.infinite && !_this2._canSlideRight()) {
              _this2.pause();
            } else {
              _this2.slideToIndex(_this2.state.currentIndex + 1);
            }
          }
        }, Math.max(slideInterval, slideDuration));

        if (this.props.onPlay && callback) {
          this.props.onPlay(this.state.currentIndex);
        }
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      var callback = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (this._intervalId) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
        this.setState({ isPlaying: false });

        if (this.props.onPause && callback) {
          this.props.onPause(this.state.currentIndex);
        }
      }
    }
  }, {
    key: 'setModalFullscreen',
    value: function setModalFullscreen(state) {
      this.setState({ modalFullscreen: state });
      // manually call because browser does not support screenchange events
      if (this.props.onScreenChange) {
        this.props.onScreenChange(state);
      }
    }
  }, {
    key: 'fullScreen',
    value: function fullScreen() {
      var gallery = this._imageGallery;

      if (this.props.useBrowserFullscreen) {
        if (gallery.requestFullscreen) {
          gallery.requestFullscreen();
        } else if (gallery.msRequestFullscreen) {
          gallery.msRequestFullscreen();
        } else if (gallery.mozRequestFullScreen) {
          gallery.mozRequestFullScreen();
        } else if (gallery.webkitRequestFullscreen) {
          gallery.webkitRequestFullscreen();
        } else {
          // fallback to fullscreen modal for unsupported browsers
          this.setModalFullscreen(true);
        }
      } else {
        this.setModalFullscreen(true);
      }

      this.setState({ isFullscreen: true });
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      if (this.state.isFullscreen) {
        if (this.props.useBrowserFullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else {
            // fallback to fullscreen modal for unsupported browsers
            this.setModalFullscreen(false);
          }
        } else {
          this.setModalFullscreen(false);
        }

        this.setState({ isFullscreen: false });
      }
    }
  }, {
    key: 'getCurrentIndex',
    value: function getCurrentIndex() {
      return this.state.currentIndex;
    }
  }, {
    key: '_onScreenChangeEvent',
    value: function _onScreenChangeEvent() {
      var _this3 = this;

      screenChangeEvents.map(function (eventName) {
        document.addEventListener(eventName, _this3._handleScreenChange);
      });
    }
  }, {
    key: '_offScreenChangeEvent',
    value: function _offScreenChangeEvent() {
      var _this4 = this;

      screenChangeEvents.map(function (eventName) {
        document.removeEventListener(eventName, _this4._handleScreenChange);
      });
    }
  }, {
    key: '_isThumbnailHorizontal',
    value: function _isThumbnailHorizontal() {
      var thumbnailPosition = this.props.thumbnailPosition;

      return thumbnailPosition === 'left' || thumbnailPosition === 'right';
    }
  }, {
    key: '_handleMouseOverThumbnails',
    value: function _handleMouseOverThumbnails(index) {
      var _this5 = this;

      if (this.props.slideOnThumbnailHover) {
        this.setState({ hovering: true });
        if (this._thumbnailTimer) {
          window.clearTimeout(this._thumbnailTimer);
          this._thumbnailTimer = null;
        }
        this._thumbnailTimer = window.setTimeout(function () {
          _this5.slideToIndex(index);
        }, this._thumbnailDelay);
      }
    }
  }, {
    key: '_setScrollDirection',
    value: function _setScrollDirection(deltaX, deltaY) {
      var _state = this.state;
      var scrollingUpDown = _state.scrollingUpDown;
      var scrollingLeftRight = _state.scrollingLeftRight;

      var x = Math.abs(deltaX);
      var y = Math.abs(deltaY);

      // If y > x the user is scrolling up and down
      if (y > x && !scrollingUpDown && !scrollingLeftRight) {
        this.setState({ scrollingUpDown: true });
      } else if (!scrollingLeftRight && !scrollingUpDown) {
        this.setState({ scrollingLeftRight: true });
      }
    }
  }, {
    key: '_handleOnSwipedTo',
    value: function _handleOnSwipedTo(side, isFlick) {
      var _state2 = this.state;
      var currentIndex = _state2.currentIndex;
      var isTransitioning = _state2.isTransitioning;

      var slideTo = currentIndex;

      if ((this._sufficientSwipeOffset() || isFlick) && !isTransitioning) {
        slideTo += side;
      }

      if (side < 0) {
        if (!this._canSlideLeft()) {
          slideTo = currentIndex;
        }
      } else {
        if (!this._canSlideRight()) {
          slideTo = currentIndex;
        }
      }

      this._unthrottledSlideToIndex(slideTo);
    }
  }, {
    key: '_sufficientSwipeOffset',
    value: function _sufficientSwipeOffset() {
      return Math.abs(this.state.offsetPercentage) > this.props.swipeThreshold;
    }
  }, {
    key: '_onSwipingNoOp',
    value: function _onSwipingNoOp() {
      /*
      Do nothing, only defined so preventDefaultTouchmoveEvent works
      */
    }
  }, {
    key: '_canNavigate',
    value: function _canNavigate() {
      return this.props.items.length >= 2;
    }
  }, {
    key: '_canSlideLeft',
    value: function _canSlideLeft() {
      return this.props.infinite || this.state.currentIndex > 0;
    }
  }, {
    key: '_canSlideRight',
    value: function _canSlideRight() {
      return this.props.infinite || this.state.currentIndex < this.props.items.length - 1;
    }
  }, {
    key: '_updateThumbnailTranslate',
    value: function _updateThumbnailTranslate(prevState) {
      if (this.state.currentIndex === 0) {
        this._setThumbsTranslate(0);
      } else {
        var indexDifference = Math.abs(prevState.currentIndex - this.state.currentIndex);
        var scroll = this._getThumbsTranslate(indexDifference);
        if (scroll > 0) {
          if (prevState.currentIndex < this.state.currentIndex) {
            this._setThumbsTranslate(this.state.thumbsTranslate - scroll);
          } else if (prevState.currentIndex > this.state.currentIndex) {
            this._setThumbsTranslate(this.state.thumbsTranslate + scroll);
          }
        }
      }
    }
  }, {
    key: '_setThumbsTranslate',
    value: function _setThumbsTranslate(thumbsTranslate) {
      this.setState({ thumbsTranslate: thumbsTranslate });
    }
  }, {
    key: '_getThumbsTranslate',
    value: function _getThumbsTranslate(indexDifference) {
      if (this.props.disableThumbnailScroll) {
        return 0;
      }

      var _state3 = this.state;
      var thumbnailsWrapperWidth = _state3.thumbnailsWrapperWidth;
      var thumbnailsWrapperHeight = _state3.thumbnailsWrapperHeight;

      var totalScroll = void 0;

      if (this._thumbnails) {

        // total scroll required to see the last thumbnail
        if (this._isThumbnailHorizontal()) {
          if (this._thumbnails.scrollHeight <= thumbnailsWrapperHeight) {
            return 0;
          }
          totalScroll = this._thumbnails.scrollHeight - thumbnailsWrapperHeight;
        } else {
          if (this._thumbnails.scrollWidth <= thumbnailsWrapperWidth || thumbnailsWrapperWidth <= 0) {
            return 0;
          }
          totalScroll = this._thumbnails.scrollWidth - thumbnailsWrapperWidth;
        }

        var totalThumbnails = this._thumbnails.children.length;
        // scroll-x required per index change
        var perIndexScroll = totalScroll / (totalThumbnails - 1);

        return indexDifference * perIndexScroll;
      }
    }
  }, {
    key: '_getAlignmentClassName',
    value: function _getAlignmentClassName(index) {
      // LEFT, and RIGHT alignments are necessary for lazyLoad
      var currentIndex = this.state.currentIndex;

      var alignment = '';
      var LEFT = 'left';
      var CENTER = 'center';
      var RIGHT = 'right';

      switch (index) {
        case currentIndex - 1:
          alignment = ' ' + LEFT;
          break;
        case currentIndex:
          alignment = ' ' + CENTER;
          break;
        case currentIndex + 1:
          alignment = ' ' + RIGHT;
          break;
      }

      if (this.props.items.length >= 3 && this.props.infinite) {
        if (index === 0 && currentIndex === this.props.items.length - 1) {
          // set first slide as right slide if were sliding right from last slide
          alignment = ' ' + RIGHT;
        } else if (index === this.props.items.length - 1 && currentIndex === 0) {
          // set last slide as left slide if were sliding left from first slide
          alignment = ' ' + LEFT;
        }
      }

      return alignment;
    }
  }, {
    key: '_isGoingFromFirstToLast',
    value: function _isGoingFromFirstToLast() {
      var _state4 = this.state;
      var currentIndex = _state4.currentIndex;
      var previousIndex = _state4.previousIndex;

      var totalSlides = this.props.items.length - 1;
      return previousIndex === 0 && currentIndex === totalSlides;
    }
  }, {
    key: '_isGoingFromLastToFirst',
    value: function _isGoingFromLastToFirst() {
      var _state5 = this.state;
      var currentIndex = _state5.currentIndex;
      var previousIndex = _state5.previousIndex;

      var totalSlides = this.props.items.length - 1;
      return previousIndex === totalSlides && currentIndex === 0;
    }
  }, {
    key: '_getTranslateXForTwoSlide',
    value: function _getTranslateXForTwoSlide(index) {
      // For taking care of infinite swipe when there are only two slides
      var _state6 = this.state;
      var currentIndex = _state6.currentIndex;
      var offsetPercentage = _state6.offsetPercentage;
      var previousIndex = _state6.previousIndex;

      var baseTranslateX = -100 * currentIndex;
      var translateX = baseTranslateX + index * 100 + offsetPercentage;

      // keep track of user swiping direction
      if (offsetPercentage > 0) {
        this.direction = 'left';
      } else if (offsetPercentage < 0) {
        this.direction = 'right';
      }

      // when swiping make sure the slides are on the correct side
      if (currentIndex === 0 && index === 1 && offsetPercentage > 0) {
        translateX = -100 + offsetPercentage;
      } else if (currentIndex === 1 && index === 0 && offsetPercentage < 0) {
        translateX = 100 + offsetPercentage;
      }

      if (currentIndex !== previousIndex) {
        // when swiped move the slide to the correct side
        if (previousIndex === 0 && index === 0 && offsetPercentage === 0 && this.direction === 'left') {
          translateX = 100;
        } else if (previousIndex === 1 && index === 1 && offsetPercentage === 0 && this.direction === 'right') {
          translateX = -100;
        }
      } else {
        // keep the slide on the correct slide even when not a swipe
        if (currentIndex === 0 && index === 1 && offsetPercentage === 0 && this.direction === 'left') {
          translateX = -100;
        } else if (currentIndex === 1 && index === 0 && offsetPercentage === 0 && this.direction === 'right') {
          translateX = 100;
        }
      }

      return translateX;
    }
  }, {
    key: '_getThumbnailBarHeight',
    value: function _getThumbnailBarHeight() {
      if (this._isThumbnailHorizontal()) {
        return {
          height: this.state.gallerySlideWrapperHeight
        };
      }
      return {};
    }
  }, {
    key: '_shouldPushSlideOnInfiniteMode',
    value: function _shouldPushSlideOnInfiniteMode(index) {
      /*
        Push(show) slide if slide is the current slide, and the next slide
        OR
        The slide is going more than 1 slide left, or right, but not going from
        first to last and not going from last to first
         There is an edge case where if you go to the first or last slide, when they're
        not left, or right of each other they will try to catch up in the background
        so unless were going from first to last or vice versa we don't want the first
        or last slide to show up during our transition
      */
      return !this._slideIsTransitioning(index) || this._ignoreIsTransitioning() && !this._isFirstOrLastSlide(index);
    }
  }, {
    key: '_slideIsTransitioning',
    value: function _slideIsTransitioning(index) {
      /*
      returns true if the gallery is transitioning and the index is not the
      previous or currentIndex
      */
      var _state7 = this.state;
      var isTransitioning = _state7.isTransitioning;
      var previousIndex = _state7.previousIndex;
      var currentIndex = _state7.currentIndex;

      var indexIsNotPreviousOrNextSlide = !(index === previousIndex || index === currentIndex);
      return isTransitioning && indexIsNotPreviousOrNextSlide;
    }
  }, {
    key: '_isFirstOrLastSlide',
    value: function _isFirstOrLastSlide(index) {
      var totalSlides = this.props.items.length - 1;
      var isLastSlide = index === totalSlides;
      var isFirstSlide = index === 0;
      return isLastSlide || isFirstSlide;
    }
  }, {
    key: '_ignoreIsTransitioning',
    value: function _ignoreIsTransitioning() {
      /*
        Ignore isTransitioning because were not going to sibling slides
        e.g. center to left or center to right
      */
      var _state8 = this.state;
      var previousIndex = _state8.previousIndex;
      var currentIndex = _state8.currentIndex;

      var totalSlides = this.props.items.length - 1;
      // we want to show the in between slides transition
      var slidingMoreThanOneSlideLeftOrRight = Math.abs(previousIndex - currentIndex) > 1;
      var notGoingFromFirstToLast = !(previousIndex === 0 && currentIndex === totalSlides);
      var notGoingFromLastToFirst = !(previousIndex === totalSlides && currentIndex === 0);

      return slidingMoreThanOneSlideLeftOrRight && notGoingFromFirstToLast && notGoingFromLastToFirst;
    }
  }, {
    key: '_getSlideStyle',
    value: function _getSlideStyle(index) {
      var _state9 = this.state;
      var currentIndex = _state9.currentIndex;
      var offsetPercentage = _state9.offsetPercentage;
      var _props2 = this.props;
      var infinite = _props2.infinite;
      var items = _props2.items;
      var useTranslate3D = _props2.useTranslate3D;

      var baseTranslateX = -100 * currentIndex;
      var totalSlides = items.length - 1;

      // calculates where the other slides belong based on currentIndex
      var translateX = baseTranslateX + index * 100 + offsetPercentage;

      if (infinite && items.length > 2) {
        if (currentIndex === 0 && index === totalSlides) {
          // make the last slide the slide before the first
          translateX = -100 + offsetPercentage;
        } else if (currentIndex === totalSlides && index === 0) {
          // make the first slide the slide after the last
          translateX = 100 + offsetPercentage;
        }
      }

      // Special case when there are only 2 items with infinite on
      if (infinite && items.length === 2) {
        translateX = this._getTranslateXForTwoSlide(index);
      }

      var translate = 'translate(' + translateX + '%, 0)';

      if (useTranslate3D) {
        translate = 'translate3d(' + translateX + '%, 0, 0)';
      }

      return {
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        transform: translate
      };
    }
  }, {
    key: '_getThumbnailStyle',
    value: function _getThumbnailStyle() {
      var translate = void 0;
      var useTranslate3D = this.props.useTranslate3D;

      if (this._isThumbnailHorizontal()) {
        translate = 'translate(0, ' + this.state.thumbsTranslate + 'px)';
        if (useTranslate3D) {
          translate = 'translate3d(0, ' + this.state.thumbsTranslate + 'px, 0)';
        }
      } else {
        translate = 'translate(' + this.state.thumbsTranslate + 'px, 0)';
        if (useTranslate3D) {
          translate = 'translate3d(' + this.state.thumbsTranslate + 'px, 0, 0)';
        }
      }
      return {
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        transform: translate
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _state10 = this.state;
      var currentIndex = _state10.currentIndex;
      var isFullscreen = _state10.isFullscreen;
      var modalFullscreen = _state10.modalFullscreen;
      var isPlaying = _state10.isPlaying;
      var scrollingLeftRight = _state10.scrollingLeftRight;
      var _props3 = this.props;
      var infinite = _props3.infinite;
      var preventDefaultTouchmoveEvent = _props3.preventDefaultTouchmoveEvent;

      var thumbnailStyle = this._getThumbnailStyle();
      var thumbnailPosition = this.props.thumbnailPosition;

      var slideLeft = this._slideLeft;
      var slideRight = this._slideRight;

      var slides = [];
      var thumbnails = [];
      var bullets = [];

      this.props.items.forEach(function (item, index) {
        var alignment = _this6._getAlignmentClassName(index);
        var originalClass = item.originalClass ? ' ' + item.originalClass : '';
        var thumbnailClass = item.thumbnailClass ? ' ' + item.thumbnailClass : '';

        var renderItem = item.renderItem || _this6.props.renderItem || _this6._renderItem;

        var renderThumbInner = item.renderThumbInner || _this6.props.renderThumbInner || _this6._renderThumbInner;

        var showItem = !_this6.props.lazyLoad || alignment || _this6._lazyLoaded[index];
        if (showItem && _this6.props.lazyLoad) {
          _this6._lazyLoaded[index] = true;
        }

        var slideStyle = _this6._getSlideStyle(index);

        var slide = _react2.default.createElement('div', {
          key: index,
          className: 'image-gallery-slide' + alignment + originalClass,
          style: _extends(slideStyle, _this6.state.style),
          onClick: _this6.props.onClick,
          onTouchMove: _this6.props.onTouchMove,
          onTouchEnd: _this6.props.onTouchEnd,
          onTouchStart: _this6.props.onTouchStart,
          onMouseOver: _this6.props.onMouseOver,
          onMouseLeave: _this6.props.onMouseLeave,
          role: _this6.props.onClick && 'button'
        }, showItem ? renderItem(item) : _react2.default.createElement('div', { style: { height: '100%' } }));

        if (infinite) {
          // don't add some slides while transitioning to avoid background transitions
          if (_this6._shouldPushSlideOnInfiniteMode(index)) {
            slides.push(slide);
          }
        } else {
          slides.push(slide);
        }

        if (_this6.props.showThumbnails) {
          thumbnails.push(_react2.default.createElement('a', {
            onMouseOver: _this6._handleMouseOverThumbnails.bind(_this6, index),
            onMouseLeave: _this6._handleMouseLeaveThumbnails,
            key: index,
            role: 'button',
            'aria-pressed': currentIndex === index ? 'true' : 'false',
            'aria-label': 'Go to Slide ' + (index + 1),
            className: 'image-gallery-thumbnail' + (currentIndex === index ? ' active' : '') + thumbnailClass,
            onClick: function onClick(event) {
              _this6.slideToIndex.call(_this6, index, event);
              if (_this6.props.onThumbnailClick) {
                _this6.props.onThumbnailClick(event, index);
              }
            }
          }, renderThumbInner(item)));
        }

        if (_this6.props.showBullets) {
          var bulletOnClick = function bulletOnClick(event) {
            if (item.bulletOnClick) {
              item.bulletOnClick({ item: item, itemIndex: index, currentIndex: currentIndex });
            }
            return _this6.slideToIndex.call(_this6, index, event);
          };
          bullets.push(_react2.default.createElement('button', {
            key: index,
            type: 'button',
            className: ['image-gallery-bullet', currentIndex === index ? 'active' : '', item.bulletClass || ''].join(' '),
            onClick: bulletOnClick,
            'aria-pressed': currentIndex === index ? 'true' : 'false',
            'aria-label': 'Go to Slide ' + (index + 1)
          }));
        }
      });

      var slideWrapper = _react2.default.createElement('div', {
        ref: function ref(i) {
          return _this6._imageGallerySlideWrapper = i;
        },
        className: 'image-gallery-slide-wrapper ' + thumbnailPosition
      }, this.props.renderCustomControls && this.props.renderCustomControls(), this.props.showFullscreenButton && this.props.renderFullscreenButton(this._toggleFullScreen, isFullscreen), this.props.showPlayButton && this.props.renderPlayPauseButton(this._togglePlay, isPlaying), this._canNavigate() ? [this.props.showNav && _react2.default.createElement('span', { key: 'navigation' }, this.props.renderLeftNav(slideLeft, !this._canSlideLeft()), this.props.renderRightNav(slideRight, !this._canSlideRight())), this.props.disableSwipe ? _react2.default.createElement('div', { className: 'image-gallery-slides', key: 'slides' }, slides) : _react2.default.createElement(_reactSwipeable2.default, {
        className: 'image-gallery-swipe',
        key: 'swipeable',
        delta: 0,
        flickThreshold: this.props.flickThreshold,
        onSwiping: this._handleSwiping,
        onSwipingLeft: this._onSwipingNoOp,
        onSwipingRight: this._onSwipingNoOp,
        onSwipingUp: this._onSwipingNoOp,
        onSwipingDown: this._onSwipingNoOp,
        onSwiped: this._handleOnSwiped,
        stopPropagation: this.props.stopPropagation,
        preventDefaultTouchmoveEvent: preventDefaultTouchmoveEvent || scrollingLeftRight
      }, _react2.default.createElement('div', { className: 'image-gallery-slides' }, slides))] : _react2.default.createElement('div', { className: 'image-gallery-slides' }, slides), this.props.showBullets && _react2.default.createElement('div', { className: 'image-gallery-bullets' }, _react2.default.createElement('div', {
        className: 'image-gallery-bullets-container',
        role: 'navigation',
        'aria-label': 'Bullet Navigation'
      }, bullets)), this.props.showIndex && _react2.default.createElement('div', { className: 'image-gallery-index' }, _react2.default.createElement('span', { className: 'image-gallery-index-current' }, this.state.currentIndex + 1), _react2.default.createElement('span', { className: 'image-gallery-index-separator' }, this.props.indexSeparator), _react2.default.createElement('span', { className: 'image-gallery-index-total' }, this.props.items.length)));

      var classNames = ['image-gallery', this.props.additionalClass, modalFullscreen ? 'fullscreen-modal' : ''].filter(function (name) {
        return typeof name === 'string';
      }).join(' ');

      return _react2.default.createElement('div', {
        ref: function ref(i) {
          return _this6._imageGallery = i;
        },
        className: classNames,
        'aria-live': 'polite'
      }, _react2.default.createElement('div', {
        className: 'image-gallery-content' + (isFullscreen ? ' fullscreen' : '')
      }, (thumbnailPosition === 'bottom' || thumbnailPosition === 'right') && slideWrapper, this.props.showThumbnails && _react2.default.createElement('div', {
        className: 'image-gallery-thumbnails-wrapper ' + thumbnailPosition,
        style: this._getThumbnailBarHeight()
      }, _react2.default.createElement('div', {
        className: 'image-gallery-thumbnails',
        ref: function ref(i) {
          return _this6._thumbnailsWrapper = i;
        }
      }, _react2.default.createElement('div', {
        ref: function ref(t) {
          return _this6._thumbnails = t;
        },
        className: 'image-gallery-thumbnails-container',
        style: thumbnailStyle,
        'aria-label': 'Thumbnail Navigation'
      }, thumbnails))), (thumbnailPosition === 'top' || thumbnailPosition === 'left') && slideWrapper));
    }
  }]);

  return ImageGallery;
}(_react2.default.Component);

ImageGallery.propTypes = {
  flickThreshold: _propTypes2.default.number,
  items: _propTypes2.default.array.isRequired,
  showNav: _propTypes2.default.bool,
  autoPlay: _propTypes2.default.bool,
  lazyLoad: _propTypes2.default.bool,
  infinite: _propTypes2.default.bool,
  showIndex: _propTypes2.default.bool,
  showBullets: _propTypes2.default.bool,
  showThumbnails: _propTypes2.default.bool,
  showPlayButton: _propTypes2.default.bool,
  showFullscreenButton: _propTypes2.default.bool,
  slideOnThumbnailHover: _propTypes2.default.bool,
  disableThumbnailScroll: _propTypes2.default.bool,
  disableArrowKeys: _propTypes2.default.bool,
  disableSwipe: _propTypes2.default.bool,
  useBrowserFullscreen: _propTypes2.default.bool,
  preventDefaultTouchmoveEvent: _propTypes2.default.bool,
  defaultImage: _propTypes2.default.string,
  indexSeparator: _propTypes2.default.string,
  thumbnailPosition: _propTypes2.default.string,
  startIndex: _propTypes2.default.number,
  slideDuration: _propTypes2.default.number,
  slideInterval: _propTypes2.default.number,
  swipeThreshold: _propTypes2.default.number,
  swipingTransitionDuration: _propTypes2.default.number,
  onSlide: _propTypes2.default.func,
  onScreenChange: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onImageLoad: _propTypes2.default.func,
  onImageError: _propTypes2.default.func,
  onTouchMove: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onThumbnailError: _propTypes2.default.func,
  onThumbnailClick: _propTypes2.default.func,
  renderCustomControls: _propTypes2.default.func,
  renderLeftNav: _propTypes2.default.func,
  renderRightNav: _propTypes2.default.func,
  renderPlayPauseButton: _propTypes2.default.func,
  renderFullscreenButton: _propTypes2.default.func,
  renderItem: _propTypes2.default.func,
  stopPropagation: _propTypes2.default.bool,
  additionalClass: _propTypes2.default.string,
  useTranslate3D: _propTypes2.default.bool
};
ImageGallery.defaultProps = {
  items: [],
  showNav: true,
  autoPlay: false,
  lazyLoad: false,
  infinite: true,
  showIndex: false,
  showBullets: false,
  showThumbnails: true,
  showPlayButton: true,
  showFullscreenButton: true,
  slideOnThumbnailHover: false,
  disableThumbnailScroll: false,
  disableArrowKeys: false,
  disableSwipe: false,
  useTranslate3D: true,
  useBrowserFullscreen: true,
  preventDefaultTouchmoveEvent: false,
  flickThreshold: 0.4,
  stopPropagation: false,
  indexSeparator: ' / ',
  thumbnailPosition: 'bottom',
  startIndex: 0,
  slideDuration: 450,
  swipingTransitionDuration: 0,
  slideInterval: 3000,
  swipeThreshold: 30,
  renderLeftNav: function renderLeftNav(onClick, disabled) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-left-nav',
      disabled: disabled,
      onClick: onClick,
      'aria-label': 'Previous Slide'
    });
  },
  renderRightNav: function renderRightNav(onClick, disabled) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-right-nav',
      disabled: disabled,
      onClick: onClick,
      'aria-label': 'Next Slide'
    });
  },
  renderPlayPauseButton: function renderPlayPauseButton(onClick, isPlaying) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-play-button' + (isPlaying ? ' active' : ''),
      onClick: onClick,
      'aria-label': 'Play or Pause Slideshow'
    });
  },
  renderFullscreenButton: function renderFullscreenButton(onClick, isFullscreen) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-fullscreen-button' + (isFullscreen ? ' active' : ''),
      onClick: onClick,
      'aria-label': 'Open Fullscreen'
    });
  }
};
exports.default = ImageGallery;

/***/ }),

/***/ "ygBH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__32Z8H","rowLegend":"rowLegend__C5ms_","innerLegend":"innerLegend__1Igj1","row":"row__2z0YC","rowWrapper":"rowWrapper__3pAJu","rowWrapperItem":"rowWrapperItem__3lHd4","rowText":"rowText__3WB_V","country_percentage":"country_percentage__19Tmk","countryWrapper":"countryWrapper__P6LGH","allDonorWrapper":"allDonorWrapper__34mCZ","labelText":"labelText__385Vj","barValue":"barValue__10UpB","text":"text__2WqNp","barType":"barType__Tducy","imageWrapper":"imageWrapper__1GaFI","sdg_image":"sdg_image__uHBJJ"};

/***/ }),

/***/ "ykHf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"legend":"legend__16Bxb","textLabel":"textLabel__1joTL","exportLegend":"exportLegend__Ubl1L","legendWrapper":"legendWrapper__Vw742","legendColor":"legendColor__3Vlb7","legendDescription":"legendDescription__2fl0B","legendPercentage":"legendPercentage__1XV7M","perc":"perc__2AJLF","textField":"textField__3idj6","contributionText":"contributionText__2WWI2","dollor":"dollor__2DjDI","donut":"donut__1hbgJ","imageWrapper":"imageWrapper__wG9x0","sdg_image":"sdg_image__3iyCd","svgIe":"svgIe__2AJSS"};

/***/ }),

/***/ "zgDO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"budgetComponentWrapper":"budgetComponentWrapper__3Bh97","budgetWrapper":"budgetWrapper__1EAas","budgetHeading":"budgetHeading__27Bp9","projectWrapper":"projectWrapper__22DLY","projectPrice":"projectPrice__2I1m1","project":"project__2XXUp"};

/***/ })

});


// WEBPACK FOOTER //
// route-projectDetails.chunk.0c25e.js